import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
  ChangeDetectorRef,
  NgZone
} from "@angular/core";
import * as moment from "moment";

import { TranslateService } from "@ngx-translate/core";
import { ConfigService } from "../Services/config.service";
import * as BlinkIDSDK from "@microblink/blinkid-in-browser-sdk";
import { ErrorMessageKeyService } from "../Services/error-message-key.service";
import { CommonService } from "../Services/common.service";
import { DomSanitizer } from "@angular/platform-browser";
import { AuthService } from "../Services/auth.service";
import { CountriesService } from "../Services/countries.service";
import { Guid } from "guid-typescript";

import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NavigationStart, Router } from "@angular/router";
import { Observable, Subject } from "rxjs";
import { WebcamImage } from "ngx-webcam";
import { KycService } from "../Services/kyc.service";
import { DocList } from "../register/supporting-documents/supporting-documents.component";
import * as Config from "src/assets/i18n/en.json";
import { DeviceDetectorService } from "ngx-device-detector";
import { event } from "jquery";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { Location } from "@angular/common";
import * as APIURL from "../../assets/APIURL.json";
// import { validate } from "src/assets/scripts/vidyoclient";
//import  * as FBL from 'https://testbed.faysalbank.com/sdk/fbl.sdk.v1.min.js'
declare var window;
declare var FBL;
declare var FBLDevice;
declare var IDWise;

declare function FBLIdentityScanStartProxy({ Mobile }): any;
@Component({
  selector: "app-PAK-nationality-details",
  templateUrl: "./PAK-nationality-details.component.html",
  styleUrls: ["./PAK-nationality-details.component.scss"],
})
export class PAKnationalitydetailsComponent implements OnInit {
  WIDTH = 475;
  HEIGHT = 475;
  //script = this.renderer.createElement("script");
  @ViewChild("video")
  public video: ElementRef;

  @ViewChild("canvas")
  public canvas: ElementRef;

  captures: string[] = [];
  error: any;
  isCaptured: boolean;

  sdk: BlinkIDSDK.WasmSDK;
  combinedGenericIDRecognizer: BlinkIDSDK.BlinkIdCombinedRecognizer;
  recognizerRunner: BlinkIDSDK.RecognizerRunner;
  camerapermission: boolean = false;
  videoRecognizer: BlinkIDSDK.VideoRecognizer;
  ClientKey: string;
  JourneyId: String;
  submitAttempt: boolean = false;
  cardPlaceHolder: string = "XXXXX-XXXXXXX-X";
  cardmaask: string = "XXXXX-XXXXXXX-X";
  Gender: string = "";
  IslifeTime: boolean;
  IsNotlifeTime: boolean;
  selfieimg: any;
  IDtype: string = "";
  ScanView: boolean = false;
  terms: boolean;
  allowCameraSwitch = false;
  selectcom;

  FirstName: string = "";
  MiddleName: string = "";
  LastName: string = "";
  FatherName: string = "";

  IDNumber: string = "";
  key: string = "";

  @ViewChild("modal") Modal: ElementRef;
  ValidGender: boolean = true;
  //livenessagree: boolean = false;
  showscanid: boolean = false;
  count: number = 0;
  Selfiescan: boolean = false;
  scanFeedback: any;
  frontidcarddone: boolean = false;

  @ViewChild("modalAttachfront") modalAttachfront: ElementRef;
  @ViewChild("modalAttachback") modalAttachback: ElementRef;

  deviceInfo;
  scanImageElement;
  inputImageFileFrontSide;
  inputImageFileBackSide;
  constructor(
    private ngZone: NgZone,

    private location: Location,
    public translate: TranslateService,
    private changeDetectorRef: ChangeDetectorRef,
    public errorKey: ErrorMessageKeyService,
    private config: ConfigService,
    private commonP: CommonService,
    private Sanitizer: DomSanitizer,
    private auth: AuthService,
    private country: CountriesService,
    public formbuilder: FormBuilder,
    private _router: Router,
    public renderer: Renderer2,
    public kyc: KycService,
    private deviceService: DeviceDetectorService,
    private elementRef: ElementRef
  ) {
    translate.setDefaultLang("en");
    translate.use("en");

    _router.events.pipe().subscribe((event: NavigationStart) => {
      if (event.url == "/mobileOTP") {
        this._router.navigateByUrl("/MobileVerification");
      }
    });

    this.epicFunction();
  }
  epicFunction() {
    console.log("hello `Home` component");
    this.deviceInfo = this.deviceService.getDeviceInfo();
    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();
    const isDesktopDevice = this.deviceService.isDesktop();
    console.log(this.deviceInfo);
    console.log(isMobile); // returns if the device is a mobile device (android / iPhone / windows-phone etc)
    console.log(isTablet); // returns if the device us a tablet (iPad etc)
    console.log(isDesktopDevice); // returns if the app is running on a Desktop browser.
  }
  initialMessageEl: any;
  cameraFeed: any;
  cameraFeedback: any;
  drawContext: any;
  scanFeedbacktxt: string =
    "Please place the front side of your ID Card in front of the camera";
  scanFeedbackLock: boolean = false;
  scanfrontImg: any;
  scanbackImg: any;
  ScanType;
  scanobj: any[] = [];
  inputfrontside: any;
  inputbackside: any;
  Acceptcondition: boolean = false;
  snictype: boolean = false;
  nicoptype: boolean = false;
  cnictype: boolean = false;
  isfatherkey: boolean = true;
  ishusbandkey: boolean;
  front;
  back;
  face;

  frontHide;
  backHide;
  faceimage;
  dataCaptured = false;

  frontsuccess = false;
  backsuccess = false;
  facesuccess = false;
  frontBlob: Blob;
  backBlob: Blob;
  faceBlob: Blob;

  RegistrationForm: FormGroup;
  ScanID: boolean = false;

  DobdaySelect: string = "Day";
  DobMonthSelect: string = "Month";
  DobYearSelect: string = "Year";

  DoedaySelect: string = "Day";
  DoeMonthSelect: string = "Month";
  DoeYearSelect: string = "Year";

  issuedaySelect: string = "Day";
  issueMonthSelect: string = "Month";
  issueYearSelect: string = "Year";

  frontimage: string = "";
  backimage: string = "";

  showdoe: boolean = false;
  loginresponse;

  camobj: any[] = [];
  cameraactive: boolean = false;
  @ViewChild("modal2") Modal2: ElementRef;
  @ViewChild("imageid2") imagetag2: ElementRef;
  @ViewChild("modal3") Modal3: ElementRef;
  @ViewChild("modal4") Modal4: ElementRef;

  @ViewChild("ModalNadraslip") ModalNadraslip: ElementRef;

  private trigger: Subject<void> = new Subject<void>();
  public webcamImage: WebcamImage = null;
  imagebase64: string;
  CameraViewer: boolean = false;

  UploadNadra: boolean = false;
  ValidIdCard: boolean = false;
  CardDocumentoption: boolean = false;
  showNadraRecipte: boolean = false;
  UserRegister: boolean = false;
  close: boolean = false;
  monthlistArray = [
    {
      value: 1,
      text: "January",
    },
    {
      value: 2,
      text: "February",
    },
    {
      value: 3,
      text: "March",
    },
    {
      value: 4,
      text: "April",
    },
    {
      value: 5,
      text: "May",
    },
    {
      value: 6,
      text: "June",
    },
    {
      value: 7,
      text: "July",
    },
    {
      value: 8,
      text: "August",
    },
    {
      value: 9,
      text: "September",
    },
    {
      value: 10,
      text: "October",
    },
    {
      value: 11,
      text: "November",
    },
    {
      value: 12,
      text: "December",
    },
  ];
  scanImageElementFront;
  scanImageElementBack;
  CampTempimag: any[] = [];
  isMinorFlow: boolean = false;
  async ngOnInit() {
    // this.livenessagree = false;
    this.Acceptcondition = false;
    this.initialMessageEl = document.getElementById(
      "msg"
    ) as HTMLHeadingElement;
    this.cameraFeed = document.getElementById(
      "camera-feed"
    ) as HTMLVideoElement;
    this.cameraFeedback = document.getElementById(
      "camera-feedback"
    ) as HTMLCanvasElement;
    this.drawContext = this.cameraFeedback.getContext(
      "2d"
    ) as CanvasRenderingContext2D;
    this.scanfrontImg = document.getElementById(
      "front-image"
    ) as HTMLImageElement;
    this.scanbackImg = document.getElementById(
      "back-image"
    ) as HTMLImageElement;
    this.inputfrontside = document.getElementById(
      "image-file-front-side"
    ) as HTMLInputElement;
    this.inputbackside = document.getElementById(
      "image-file-back-side"
    ) as HTMLInputElement;

    this.scanFeedback = document.getElementById(
      "camera-guides"
    ) as HTMLParagraphElement;
    this.scanImageElementFront = document.getElementById(
      "front-image"
    ) as HTMLHeadingElement;
    this.scanImageElementBack = document.getElementById(
      "back-image"
    ) as HTMLHeadingElement;
    this.inputImageFileFrontSide = document.getElementById(
      "image-file-front-side"
    ) as HTMLHeadingElement;
    this.inputImageFileBackSide = document.getElementById(
      "image-file-back-side"
    ) as HTMLHeadingElement;

    this.RegistrationForm = this.formbuilder.group({
      IDNumber: [
        "",
        Validators.compose([Validators.required, Validators.minLength(13)]),
      ],
      FirstName: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("[a-zA-Z ]*"),
        ]),
      ],
      MiddleName: [""],
      LastName: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("[a-zA-Z ]*"),
        ]),
      ],
      FatherName: ["", Validators.compose([Validators.required, Validators.pattern("[a-zA-Z ]*")])],
      Gender: ["", Validators.compose([Validators.required])],

      DobdaySelect: ["", Validators.compose([Validators.required])],
      DobMonthSelect: ["", Validators.compose([Validators.required])],
      DobYearSelect: ["", Validators.compose([Validators.required])],

      DoedaySelect: [""],
      DoeMonthSelect: [""],
      DoeYearSelect: [""],

      issuedaySelect: [""],
      issueMonthSelect: [""],
      issueYearSelect: [""],
    });

    ////Dates Handling
    this.doemin = moment().add(1, "days").format("YYYY-MM-DD");
    this.doemax = moment().add(12, "years").format("YYYY-MM-DD");
    this.dobmax = moment().add(-18, "years").format("YYYY-MM-DD");
    this.issuemax = moment().format("YYYY-MM-DD");

    const DOBYEARS = () => {
      const years = [];
      const dateStart = moment().add(-100, "years");
      const dateEnd = moment().add(-18, "y");
      while (dateEnd.diff(dateStart, "years") >= 0) {
        years.push(dateStart.format("YYYY"));
        dateStart.add(1, "year");
      }
      return years;
    };
    this.dobmaxarray = DOBYEARS();
    this.dobmaxarray.sort((one, two) => (one > two ? -1 : 1));

    const DOEYEARS = () => {
      const years = [];

      const dateStart = moment();
      const dateEnd = moment().add(12, "y");
      while (dateEnd.diff(dateStart, "years") >= 0) {
        years.push(dateStart.format("YYYY"));
        dateStart.add(1, "year");
      }
      return years;
    };
    this.doeyears = DOEYEARS();
    this.doeyears.sort((one, two) => (one > two ? -1 : 1));

    const IssueYEARS = () => {
      const years = [];

      const dateStart = moment().add(-100, "y");
      const dateEnd = moment();
      while (dateEnd.diff(dateStart, "years") >= 0) {
        years.push(dateStart.format("YYYY"));
        dateStart.add(1, "year");
      }
      return years;
    };
    this.issuedateyears = IssueYEARS();
    this.issuedateyears.sort((one, two) => (one > two ? -1 : 1));

    for (var i = 1; i <= 31; i++) {
      this.dobdayslistArray.push(i.toString());
      this.doedayslistArray.push(i.toString());
      this.issuedayslistArray.push(i.toString());
    }

    this.commonP.presentLoading();
    debugger
    this.auth.accessToken = await this.commonP.Get("token");
    this.kyc.IDCardexpire = await this.commonP.Get("idcardexpire");

    this.isMinorFlow = await this.commonP.Get("minor") ? true : false;
    if (this.isMinorFlow) {
      this.loginresponse = await this.commonP.Get("User");

    }
    if (this.kyc.IDCardexpire == "Card-Expire") {
      debugger
      this.UploadNadra = true;
      this.showscanid = false;
      this.ValidIdCard = false;
      this.CardDocumentoption = true;
      this.close = true;
      this.commonP.hideLoading();

      // this.showPopupNadraslip();
    } else {
      this.close = false;
      this.ValidIdCard = true;
      this.UploadNadra = false;
      this.showscanid = true;
      this.CardDocumentoption = false;
      this.commonP.hideLoading();
      // this.renderer.removeChild(this.elementRef.nativeElement, this.script);

      //fahad
      //await this.showPopup();

      let aaaaa: any = await this.auth.GetFromJson();
      console.log("Resposne from FIle", aaaaa.Blink);
      this.JourneyId = aaaaa.IdWisejourneyID;
      this.ClientKey = aaaaa.IdWise;



      await this.IDCard();

    }

  }

  async blinksetup() {
    this.combinedGenericIDRecognizer =
      await BlinkIDSDK.createBlinkIdCombinedRecognizer(this.sdk);
    const settings = await this.combinedGenericIDRecognizer.currentSettings();

    settings["returnEncodedFaceImage"] = true;
    settings["returnEncodedFullDocumentImage"] = true;
    settings["returnEncodedSignatureImage"] = true;
    this.frontidcarddone = false;
    await this.combinedGenericIDRecognizer.updateSettings(settings);
    this.Permission();

    const callbacks = {
      onQuadDetection: (quad: BlinkIDSDK.DisplayableQuad) =>
        this.drawQuad(quad),
      onDetectionFailed: () =>
        this.updateScanFeedback(this.scanFeedbacktxt, true),
      onFirstSideResult: () => this.sucessfull(),
    };

    this.recognizerRunner = await BlinkIDSDK.createRecognizerRunner(
      this.sdk,
      [this.combinedGenericIDRecognizer],
      false,
      callbacks
    );
  }
  sucessfull() {
    this.translate.get(["Infocard", "flipdocument", "OK"]).subscribe((data) => {
      this.commonP
        .showSuccessAlert(
          data.Infocard,
          data.flipdocument,
          data.Ok,
          this._router
        )
        .then((data: any) => {
          console.log("djnv", data);
          if (data) {
            console.log("djnv");
            clearInterval(this.showHandle);
          }
        });
    });

    this.frontidcarddone = true;
  }

  uploadCardImage() {
    Swal.fire({
      title: "Sorry!",
      html: "Your ID Card could not be detected. Please upload an image of your ID Card",
      icon: "error",
      allowOutsideClick: false,
    }).then((result) => {
      this.ValidIdCard = false;
      this.showNadraRecipte = false;
      this.CardDocumentoption = false;
      this.stopBlink = true;
      clearInterval(this.showHandle);
    });
  }
  uploadCardImageError(text) {
    Swal.fire({
      title: "Sorry!",
      html: text,
      icon: "error",
      allowOutsideClick: false,
    }).then((result) => {
      this.IDCard();
    });
  }
  drawQuad(quad: BlinkIDSDK.DisplayableQuad) {
    this.clearDrawCanvas();
    this.setupColor(quad);
    this.setupMessage(quad);
    this.applyTransform(quad.transformMatrix);
    this.drawContext.beginPath();
    this.drawContext.moveTo(quad.topLeft.x, quad.topLeft.y);
    this.drawContext.lineTo(quad.topRight.x, quad.topRight.y);
    this.drawContext.lineTo(quad.bottomRight.x, quad.bottomRight.y);
    this.drawContext.lineTo(quad.bottomLeft.x, quad.bottomLeft.y);
    this.drawContext.closePath();
    this.drawContext.stroke();
  }

  clearDrawCanvas() {
    this.cameraFeedback.width = this.cameraFeedback.clientWidth;
    this.cameraFeedback.height = this.cameraFeedback.clientHeight;
    this.drawContext.clearRect(
      0,
      0,
      this.cameraFeedback.width,
      this.cameraFeedback.height
    );
  }

  setupColor(displayable: BlinkIDSDK.Displayable) {
    let color = "#FFFF00FF";
    if (displayable.detectionStatus === 0) {
      color = "#FF0000FF";
    } else if (displayable.detectionStatus === 1) {
      color = "#00FF00FF";
    }
    this.drawContext.fillStyle = color;
    this.drawContext.strokeStyle = color;
    this.drawContext.lineWidth = 5;
  }

  async setupMessage(displayable: BlinkIDSDK.Displayable) {
    switch (displayable.detectionStatus) {
      case BlinkIDSDK.DetectionStatus.Fail:
        if (this.frontidcarddone) {
          await this.updateScanFeedback(
            "Please place the back side of your ID Card in front of the camera"
          );
          break;
        } else {
          await this.updateScanFeedback(
            "Please place the front side of your ID Card in front of the camera"
          );
          break;
        }

      case BlinkIDSDK.DetectionStatus.Success:
        // case BlinkIDSDK.DetectionStatus.FallbackSuccess:
        await this.updateScanFeedback("Scanning...");
        break;
      case BlinkIDSDK.DetectionStatus.CameraAtAngle:
        // await this.updateScanFeedback("Adjust the angle");
        this.updateScanFeedback("");
        break;
      case BlinkIDSDK.DetectionStatus.CameraTooHigh:
        await this.updateScanFeedback("Move document closer");

        break;
      case BlinkIDSDK.DetectionStatus.CameraTooNear:
      case BlinkIDSDK.DetectionStatus.DocumentTooCloseToEdge:
      case BlinkIDSDK.DetectionStatus.Partial:
        await this.updateScanFeedback("Move document farther");
        break;
      default:
        console.log("Unhandled detection status!", displayable.detectionStatus);
    }
  }

  applyTransform(transformMatrix: Float32Array) {
    const canvasAR = this.cameraFeedback.width / this.cameraFeedback.height;
    const videoAR = this.cameraFeed.videoWidth / this.cameraFeed.videoHeight;

    let xOffset = 0;
    let yOffset = 0;
    let scaledVideoHeight = 0;
    let scaledVideoWidth = 0;

    if (canvasAR > videoAR) {
      scaledVideoHeight = this.cameraFeedback.height;
      scaledVideoWidth = videoAR * scaledVideoHeight;
      xOffset = (this.cameraFeedback.width - scaledVideoWidth) / 2.0;
    } else {
      scaledVideoWidth = this.cameraFeedback.width;
      scaledVideoHeight = scaledVideoWidth / videoAR;
      yOffset = (this.cameraFeedback.height - scaledVideoHeight) / 2.0;
    }
    this.drawContext.translate(xOffset, yOffset);

    this.drawContext.scale(
      scaledVideoWidth / this.cameraFeed.videoWidth,
      scaledVideoHeight / this.cameraFeed.videoHeight
    );

    this.drawContext.transform(
      transformMatrix[0],
      transformMatrix[3],
      transformMatrix[1],
      transformMatrix[4],
      transformMatrix[2],
      transformMatrix[5]
    );
  }

  async updateScanFeedback(message: string, force?: boolean) {
    if (this.scanFeedbackLock && !force) {
      return;
    }
    this.scanFeedbackLock = true;
    this.scanFeedbacktxt = message;
    window.setTimeout(() => (this.scanFeedbackLock = false), 1000);
  }

  Uint8ToBase64(u8Arr: any) {
    try {
      var CHUNK_SIZE = 0x8000; //arbitrary number
      var index = 0;
      var length = u8Arr.length;
      var result = "";
      var slice;
      while (index < length) {
        slice = u8Arr.subarray(index, Math.min(index + CHUNK_SIZE, length));
        result += String.fromCharCode.apply(null, slice);
        index += CHUNK_SIZE;
      }
      return btoa(result);
    } catch (e) {
      alert(e);
    }
  }

  async mainupload() {
    this.commonP.presentLoading();
    // Check if browser has proper support for WebAssembly
    if (!BlinkIDSDK.isBrowserSupported()) {
      this.initialMessageEl.innerText = "This browser is not supported!";
      return;
    }

    // [OPTIONAL] Change default settings

    // Show or hide hello message in browser console when WASM is successfully loaded

    //let key = await this.commonP.Get("BlinkIDWeb");
    // let key = APIURL.Blink;
    //"sRwAAAYJbG9jYWxob3N0r/lOPgo/w35CpJmmKxU5Zjv9gDMK79Gwry8TRlpE0v0UOdBDN9ok1n/HyQW54+TL8S4EofGG/b+YTHTLL0rx766lloP5eeqm508nEO4IUPgY08zwkWb7pCfSTDolsxGHb3Mr/wGJvKO8niPdcbu1QHZhxrrjACycimvN0YHt1jRrptOFb9QUba4e+GziiVk+rDMWh6NWQr4izzDtmdtBjpgRC7XQQ/pbhO4=";
    let aaaaa: any = await this.auth.GetFromJson();
    console.log("Resposne from FIle", aaaaa.Blink);
    this.key = aaaaa.Blink;
    console.log("after key", this.key);
    let url = await this.commonP.Get("Deploytest");
    if (this.key) {
      console.log("Key", this.key);
      const loadSettings = new BlinkIDSDK.WasmSDKLoadSettings(this.key);
      loadSettings.allowHelloMessage = true;
      // if (!url) {
      //   loadSettings.engineLocation = url;
      // } else {
      loadSettings.engineLocation =
        window.location.origin + "/Resident/assets/resources";
      loadSettings.workerLocation =
        window.location.origin + "/Resident/assets/resources/BlinkIDWasmSDK.worker.min.js";


      // loadSettings.engineLocation =
      //   window.location.origin + "/assets/resources";
      // loadSettings.workerLocation =
      //   window.location.origin + "/assets/resources/BlinkIDWasmSDK.worker.min.js";



      //  }

      // 3. Load SDK
      BlinkIDSDK.loadWasmModule(loadSettings).then(
        async (sdk) => {
          //  document.getElementById("screen-scanning")?.classList.add("hidden");
          await this.getcountry();
          await this.startCardimage(sdk);
        },
        (error) => {
          this.initialMessageEl.innerText = "Failed to load SDK!";
          console.error("Failed to load SDK!", error);
        }
      );
    } else {
      await this.commonP.hideLoading();
      this.translate.get(["Sorry", "LinsencekeyM", "OK"]).subscribe((data) => {
        this.commonP.ParseErrorAlert(
          data.Sorry,
          data.OK,
          this._router,
          data.LinsencekeyM
        );
      });
    }
  }
  isManual: boolean = false;
  NextManual() {
    let _self = this;
    _self.IslifeTime = false;
    _self.IsNotlifeTime = false;
    _self.cnictype = false;
    _self.snictype = false;

    this.RegistrationForm = this.formbuilder.group({
      IDNumber: [
        "",
        Validators.compose([Validators.required, Validators.minLength(13)]),
      ],
      FirstName: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("[a-zA-Z ]*"),
        ]),
      ],
      MiddleName: [""],
      LastName: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("[a-zA-Z ]*"),
        ]),


      ],
      FatherName: ["", Validators.compose([Validators.required, Validators.pattern("[a-zA-Z ]*")])],
      Gender: ["", Validators.compose([Validators.required])],

      DobdaySelect: ["", Validators.compose([Validators.required])],
      DobMonthSelect: ["", Validators.compose([Validators.required])],
      DobYearSelect: ["", Validators.compose([Validators.required])],

      DoedaySelect: [""],
      DoeMonthSelect: [""],
      DoeYearSelect: [""],

      issuedaySelect: ["", Validators.compose([Validators.required])],
      issueMonthSelect: ["", Validators.compose([Validators.required])],
      issueYearSelect: ["", Validators.compose([Validators.required])],
    });
    this.issuedaySelect = "";
    this.issueMonthSelect = "";
    this.issueYearSelect = "";

    //this.ValidIdCard = true;
    var docImage = this.frontimagebase64;
    _self.front = _self.Sanitizer.bypassSecurityTrustUrl(
      "data:image/jpg;base64, " + docImage
    );
    _self.frontBlob = _self.dataURLtoBlob("data:image/jpg;base64, " + docImage);
    _self.auth.registrationfblObject.frontCardImage = docImage;
    _self.frontHide = "1";
    _self.frontsuccess = true;

    var backImage = this.backimagebase64;
    if (backImage) {
      _self.back = _self.Sanitizer.bypassSecurityTrustUrl(
        "data:image/jpg;base64, " + backImage
      );
      _self.backBlob = _self.dataURLtoBlob(
        "data:image/jpg;base64, " + backImage
      );
      _self.auth.registrationfblObject.backCardImage = backImage;
      _self.frontHide = "1";
      _self.frontsuccess = true;
    }

    document.getElementById("screen-start")?.classList.remove("hidden");
    document.getElementById("screen-scanning")?.classList.add("hidden");
    document.getElementById("show-upload-card")?.classList.add("hidden");
    this.ValidGender = false;
    _self.ValidIdCard = true;
    _self.DobdaySelect = "";
    _self.UserRegister = true;
    _self.auth.registrationfblObject.documentCode = "I";
    _self.auth.registrationfblObject.nationality = "PAK";
    _self.auth.registrationfblObject.issuer = "PAK";
    _self.auth.registrationfblObject.countryID = "PAK";
    _self.auth.registrationfblObject.documentCode = "I";
    _self.auth.registrationfblObject.nationality = "PAK";
    _self.auth.registrationfblObject.issuer = "PAK";
    _self.auth.registrationfblObject.countryID = "PAK";
  }
  lifeTimeChange(type, value) {
    this.DoedaySelect = "";
    this.DoeMonthSelect = "";
    this.DoeYearSelect = "";
    if (type == "nolifetime") {
      this.IslifeTime = false;
      this.auth.registrationfblObject.IsLifeTimeCnic = value;

      this.IsNotlifeTime = true;

      this.showdoe = true;
    } else {
      this.IslifeTime = true;
      this.IsNotlifeTime = false;
      this.showdoe = false;
      this.auth.registrationfblObject.IsLifeTimeCnic = value;
    }
    this.DoedaySelect = "";
    this.DoeMonthSelect = "";
    this.DoeYearSelect = "";
    this.doeError = "";
    this.doestring = "";
    this.auth.registrationfblObject.dOE = "";
    this.RegistrationForm.patchValue({ DOE: null });
  }
  cnicChange(type, value) {
    if (type == "scnic") {
      this.snictype = true;
      this.cnictype = false;
      this.IDtype = "SNIC";
    } else {
      this.snictype = false;
      this.cnictype = true;
      this.IDtype = "CNIC";
    }
  }
  StartManualID() {
    this.isManual = true;
    this.ValidIdCard = false;
    this.showNadraRecipte = false;
    this.CardDocumentoption = false;
    this.stopBlink = true;
    this.UserRegister = false;
    this.showscanid = false;
    this.renderer.removeClass(this.Modal.nativeElement, "active");
    document.getElementById("screen-start")?.classList.remove("hidden");
    document.getElementById("screen-scanning")?.classList.add("hidden");
    document.getElementById("show-upload-card")?.classList.remove("hidden");
    //this.uploadCardImage();
  }

  //Bio SDK
  async checkSDK() {
    let _self = this;
    await this.commonP.presentLoading();
    document.getElementById("show-upload-card")?.classList.add("hidden");

    // Move your existing code for starting CNIC Scanning in this block.

    // this.script.src = "https://testbed.faysalbank.com/sdk/fbl.sdk.v1.min.js";
    //this.script.onload = async () => {
    console.log("script loaded");

    if (FBLDevice.Environment.IsNative) {
      //   await this.commonP.presentLoading();
      await this.getcountry();
      // await this.showPopup();
      this.StartManualID();
    } else {
      if (!BlinkIDSDK.isBrowserSupported()) {
        this.translate
          .get(["Sorry", "notsupported", "OK"])
          .subscribe((data) => {
            this.commonP.ParseErrorAlert(
              data.Sorry,
              data.OK,
              this._router,
              data.notsupported
            );
          });
        return;
      }

      //let key = await this.commonP.Get("BlinkIDWeb");

      //"sRwAAAYJbG9jYWxob3N0r/lOPgo/w35CpJmmKxU5Zjv9gDMK79Gwry8TRlpE0v0UOdBDN9ok1n/HyQW54+TL8S4EofGG/b+YTHTLL0rx766lloP5eeqm508nEO4IUPgY08zwkWb7pCfSTDolsxGHb3Mr/wGJvKO8niPdcbu1QHZhxrrjACycimvN0YHt1jRrptOFb9QUba4e+GziiVk+rDMWh6NWQr4izzDtmdtBjpgRC7XQQ/pbhO4=";
      let aaaaa: any = await this.auth.GetFromJson();
      console.log("Resposne from FIle", aaaaa.Blink);
      this.key = aaaaa.Blink;
      console.log("after key", this.key);
      let url = await this.commonP.Get("Deploytest");
      console.log(url, "url");
      if (this.key) {
        console.log("Key", this.key);
        const loadSettings = new BlinkIDSDK.WasmSDKLoadSettings(this.key);
        loadSettings.allowHelloMessage = true;
        // loadSettings.thoroughScanFromImage =true;
        // if (!url) {
        //   console.log("api url", url);
        //   loadSettings.engineLocation = url;
        // } else {
        loadSettings.engineLocation =
          window.location.origin + "/Resident/assets/resources";

        loadSettings.workerLocation =
          window.location.origin + "/Resident/assets/resources/BlinkIDWasmSDK.worker.min.js";

        // loadSettings.engineLocation =
        //   window.location.origin + "/assets/resources";
        // loadSettings.workerLocation =
        //   window.location.origin + "/assets/resources/BlinkIDWasmSDK.worker.min.js";

        console.log(
          "local path",
          window.location.origin + "Resident/assets/resources"
        );
        // }

        BlinkIDSDK.loadWasmModule(loadSettings).then(
          async (sdk) => {
            document.getElementById("screen-initial")?.classList.add("hidden");
            document.getElementById("screen-start")?.classList.remove("hidden");
            this.sdk = sdk;
            await this.getcountry();
            await this.showPopup();

            await this.commonP.hideLoading();
          },
          async (error) => {
            await this.commonP.hideLoading();
            this.translate
              .get(["Sorry", "Failedsdk", "OK"])
              .subscribe((data) => {
                this.commonP.ParseErrorAlert(
                  data.Sorry,
                  data.OK,
                  this._router,
                  data.Failedsdk
                );
              });
            this.ScanView = true;
            console.log(error);
          }
        );
      } else {
        await this.commonP.hideLoading();
        this.translate
          .get(["Sorry", "LinsencekeyM", "OK"])
          .subscribe((data) => {
            this.commonP.ParseErrorAlert(
              data.Sorry,
              data.OK,
              this._router,
              data.LinsencekeyM
            );
          });
      }
    }
    //};

    //this.renderer.appendChild(this.elementRef.nativeElement, this.script);
  }

  //Manual
  // async checkSDK() {
  //   let _self = this;
  //   await this.commonP.presentLoading();
  //   document.getElementById("show-upload-card")?.classList.add("hidden");

  //   // Move your existing code for starting CNIC Scanning in this block.

  //   // this.script.src = "https://testbed.faysalbank.com/sdk/fbl.sdk.v1.min.js";
  //   //this.script.onload = async () => {
  //   console.log("script loaded");

  //   if (FBLDevice.Environment.IsNative) {
  //     //   await this.commonP.presentLoading();
  //     await this.getcountry();
  //     // await this.showPopup();
  //     this.StartManualID();
  //   } else {
  //     if (!BlinkIDSDK.isBrowserSupported()) {
  //       this.translate
  //         .get(["Sorry", "notsupported", "OK"])
  //         .subscribe((data) => {
  //           this.commonP.ParseErrorAlert(
  //             data.Sorry,
  //             data.OK,
  //             this._router,
  //             data.notsupported
  //           );
  //         });
  //       return;
  //     }

  //     //let key = await this.commonP.Get("BlinkIDWeb");

  //     //"sRwAAAYJbG9jYWxob3N0r/lOPgo/w35CpJmmKxU5Zjv9gDMK79Gwry8TRlpE0v0UOdBDN9ok1n/HyQW54+TL8S4EofGG/b+YTHTLL0rx766lloP5eeqm508nEO4IUPgY08zwkWb7pCfSTDolsxGHb3Mr/wGJvKO8niPdcbu1QHZhxrrjACycimvN0YHt1jRrptOFb9QUba4e+GziiVk+rDMWh6NWQr4izzDtmdtBjpgRC7XQQ/pbhO4=";
  //     let aaaaa: any = await this.auth.GetFromJson();
  //     console.log("Resposne from FIle", aaaaa.Blink);
  //     this.key = aaaaa.Blink;
  //     console.log("after key", this.key);
  //     let url = await this.commonP.Get("Deploytest");
  //     console.log(url, "url");
  //     if (this.key) {
  //       console.log("Key", this.key);
  //       const loadSettings = new BlinkIDSDK.WasmSDKLoadSettings(this.key);
  //       loadSettings.allowHelloMessage = true;
  //       // loadSettings.thoroughScanFromImage =true;
  //       // if (!url) {
  //       //   console.log("api url", url);
  //       //   loadSettings.engineLocation = url;
  //       // } else {
  //     //  loadSettings.engineLocation =
  //      //   window.location.origin + "/Resident/assets/resources";

  //   // loadSettings.workerLocation =
  //    // window.location.origin + "/Resident/assets/resources/BlinkIDWasmSDK.worker.min.js";

  //       loadSettings.engineLocation =
  //        window.location.origin + "/assets/resources";
  //        loadSettings.workerLocation =
  //      window.location.origin + "/assets/resources/BlinkIDWasmSDK.worker.min.js";

  //       console.log(
  //         "local path",
  //         window.location.origin + "Resident/assets/resources"
  //       );
  //       // }

  //       BlinkIDSDK.loadWasmModule(loadSettings).then(
  //         async (sdk) => {
  //           document.getElementById("screen-initial")?.classList.add("hidden");
  //           document.getElementById("screen-start")?.classList.remove("hidden");
  //           this.sdk = sdk;
  //           await this.getcountry();
  //           await this.showPopup();

  //           await this.commonP.hideLoading();
  //         },
  //         async (error) => {
  //           await this.commonP.hideLoading();
  //           this.translate
  //             .get(["Sorry", "Failedsdk", "OK"])
  //             .subscribe((data) => {
  //               this.commonP.ParseErrorAlert(
  //                 data.Sorry,
  //                 data.OK,
  //                 this._router,
  //                 data.Failedsdk
  //               );
  //             });
  //           this.ScanView = true;
  //           console.log(error);
  //         }
  //       );
  //     } else {
  //       await this.commonP.hideLoading();
  //       this.translate
  //         .get(["Sorry", "LinsencekeyM", "OK"])
  //         .subscribe((data) => {
  //           this.commonP.ParseErrorAlert(
  //             data.Sorry,
  //             data.OK,
  //             this._router,
  //             data.LinsencekeyM
  //           );
  //         });
  //     }
  //   }
  //};

  //this.renderer.appendChild(this.elementRef.nativeElement, this.script);
  // }

  //Manual
  // async checkSDK() {
  //   let _self = this;
  //   await this.commonP.presentLoading();
  //   document.getElementById("show-upload-card")?.classList.add("hidden");

  //   // Move your existing code for starting CNIC Scanning in this block.

  //   // this.script.src = "https://testbed.faysalbank.com/sdk/fbl.sdk.v1.min.js";
  //   //this.script.onload = async () => {
  //   console.log("script loaded");

  //   // if (FBLDevice.Environment.IsNative) {
  //   //   //   await this.commonP.presentLoading();
  //   //   await this.getcountry();
  //   //   // await this.showPopup();
  //   //   this.StartManualID();
  //   // } else {
  //   //   if (!BlinkIDSDK.isBrowserSupported()) {
  //   //     this.translate
  //   //       .get(["Sorry", "notsupported", "OK"])
  //   //       .subscribe((data) => {
  //   //         this.commonP.ParseErrorAlert(
  //   //           data.Sorry,
  //   //           data.OK,
  //   //           this._router,
  //   //           data.notsupported
  //   //         );
  //   //       });
  //   //     return;
  //   //   }

  //   //let key = await this.commonP.Get("BlinkIDWeb");

  //   //"sRwAAAYJbG9jYWxob3N0r/lOPgo/w35CpJmmKxU5Zjv9gDMK79Gwry8TRlpE0v0UOdBDN9ok1n/HyQW54+TL8S4EofGG/b+YTHTLL0rx766lloP5eeqm508nEO4IUPgY08zwkWb7pCfSTDolsxGHb3Mr/wGJvKO8niPdcbu1QHZhxrrjACycimvN0YHt1jRrptOFb9QUba4e+GziiVk+rDMWh6NWQr4izzDtmdtBjpgRC7XQQ/pbhO4=";
  //   let aaaaa: any = await this.auth.GetFromJson();
  //   console.log("Resposne from FIle", aaaaa.Blink);
  //   this.key = aaaaa.Blink;
  //   console.log("after key", this.key);
  //   let url = await this.commonP.Get("Deploytest");
  //   console.log(url, "url");
  //   if (this.key) {
  //     console.log("Key", this.key);
  //     const loadSettings = new BlinkIDSDK.WasmSDKLoadSettings(this.key);
  //     loadSettings.allowHelloMessage = true;
  //     // loadSettings.thoroughScanFromImage =true;
  //     // if (!url) {
  //     //   console.log("api url", url);
  //     //   loadSettings.engineLocation = url;
  //     // } else {
  //     //    loadSettings.engineLocation =
  //     //    window.location.origin + "/Resident/assets/resources";

  //     // loadSettings.workerLocation =
  //     // window.location.origin + "/Resident/assets/resources/BlinkIDWasmSDK.worker.min.js";

  //     loadSettings.engineLocation =
  //       window.location.origin + "/assets/resources";
  //     loadSettings.workerLocation =
  //       window.location.origin + "/assets/resources/BlinkIDWasmSDK.worker.min.js";

  //     console.log(
  //       "local path",
  //       window.location.origin + "Resident/assets/resources"
  //     );
  //     // }

  //     BlinkIDSDK.loadWasmModule(loadSettings).then(
  //       async (sdk) => {
  //         document.getElementById("screen-initial")?.classList.add("hidden");
  //         document.getElementById("screen-start")?.classList.remove("hidden");
  //         this.sdk = sdk;
  //         await this.getcountry();
  //         await this.showPopup();

  //         await this.commonP.hideLoading();
  //       },
  //       async (error) => {
  //         await this.commonP.hideLoading();
  //         this.translate
  //           .get(["Sorry", "Failedsdk", "OK"])
  //           .subscribe((data) => {
  //             this.commonP.ParseErrorAlert(
  //               data.Sorry,
  //               data.OK,
  //               this._router,
  //               data.Failedsdk
  //             );
  //           });
  //         this.ScanView = true;
  //         console.log(error);
  //       }
  //     );
  //   } else {
  //     await this.commonP.hideLoading();
  //     this.translate
  //       .get(["Sorry", "LinsencekeyM", "OK"])
  //       .subscribe((data) => {
  //         this.commonP.ParseErrorAlert(
  //           data.Sorry,
  //           data.OK,
  //           this._router,
  //           data.LinsencekeyM
  //         );
  //       });
  //   }
  //   //}
  //   //};

  //   //this.renderer.appendChild(this.elementRef.nativeElement, this.script);
  // }
  async getImageFrame(file: File, side): Promise<BlinkIDSDK.CapturedFrame> {
    console.log(File, side, "File", this.scanImageElementFront);
    if (side == "Front") {
      debugger;
      document.getElementById("start-front")?.classList.remove("hidden");

      this.scanImageElementFront.src = URL.createObjectURL(file);
      await this.scanImageElementFront.decode();
      console.log(
        this.scanImageElementFront.decode(),
        "this.scanImageElementFront.decode()"
      );

      return BlinkIDSDK.captureFrame(this.scanImageElementFront);
    } else {
      debugger;
      document.getElementById("start-back")?.classList.remove("hidden");
      this.scanImageElementBack.src = URL.createObjectURL(file);
      await this.scanImageElementBack.decode();
      return BlinkIDSDK.captureFrame(this.scanImageElementBack);
    }
  }
  showHandle;
  showform: boolean = false;
  stopBlink: boolean = false;
  //BioSDK
  // async startScan() {
  //   let _self = this;
  //   _self.Acceptcondition = false;
  //   _self.livenessagree = false;
  //   _self.hidePopup();
  //   if (this.CardDocumentoption) {
  //     let get_id = document.getElementById("label-04") as HTMLInputElement;
  //     get_id.checked = true;
  //   }

  //   // 1. Create a recognizer objects which will be used to recognize single image or stream of images.
  //   //
  //   // Generic ID Recognizer - scan various ID documents
  //   // ID Barcode Recognizer - scan barcodes from various ID documents
  //   //const genericIDRecognizer = await BlinkIDSDK.createBlinkIdRecognizer(sdk);
  //   if (FBLDevice.Environment.IsNative) {
  //     document.getElementById("show-upload-card")?.classList.add("hidden");

  //     // await this.commonP.presentLoading();
  //     //await this.getcountry();
  //     //await this.showPopup();

  //     //await this.commonP.hideLoading();
  //     // Start Identity Document Scanning on Native. Parameters (Mobile Number)

  //     FBLIdentityScanStartProxy({
  //       Mobile: this.auth.data.mobileNumber,
  //     });

  //     // Process Success Result for Identity Document Scanning

  //     FBL.Activities.IdentityScan.OnSuccess(async (result) => {
  //       //alert("Success");

  //       // console.log(result);
  //       this.ValidIdCard = true;
  //       // console.log(JSON.stringify(result), "IDCard Data");
  //       //   let checkdaa = JSON.parse(result);
  //       if (result) {
  //         //alert("Has data");
  //       } else {
  //         //alert("Has no data");
  //       }
  //       if (result.Response) {
  //         //alert("Has response object");
  //       } else {
  //         //alert("Has no response object");
  //       }
  //       await _self.ProcessResult(
  //         result.Response,
  //         _self,
  //         undefined,
  //         undefined,
  //         undefined
  //       );
  //       //success result from sdk
  //       // result contains the response from blinkId Identity scan.
  //     });

  //     // Process Fail Result for Identity Document Scanning

  //     FBL.Activities.IdentityScan.OnFailure(async (result) => {
  //       // alert("Failure");
  //       //alert("failed");
  //       //alert(JSON.stringify(result));

  //       // await _self.ProcessResult(
  //       //   result.Response,
  //       //   _self,
  //       //   undefined,
  //       //   undefined,
  //       //   undefined
  //       // );
  //       this.showPopup();
  //       // result contains details...
  //     });

  //     // Process System Errors for Identity Document Scanning

  //     FBL.Activities.IdentityScan.OnError(async (result) => {
  //       // alert("Error");
  //       //alert("Error");
  //       //alert(JSON.stringify(result));

  //       this.showPopup();
  //       // result contains details...
  //     });
  //   } else {
  //     document.getElementById("screen-start")?.classList.add("hidden");
  //     document.getElementById("screen-scanning")?.classList.remove("hidden");

  //     const combinedGenericIDRecognizer =
  //       await BlinkIDSDK.createBlinkIdCombinedRecognizer(this.sdk);
  //     const settings = await combinedGenericIDRecognizer.currentSettings();
  //     settings["returnEncodedFaceImage"] = true;
  //     settings["returnEncodedFullDocumentImage"] = true;
  //     settings["returnEncodedSignatureImage"] = true;
  //     // settings["thoroughScanFromImage  "] = true;
  //     await combinedGenericIDRecognizer.updateSettings(settings);

  //     // const idBarcodeRecognizer = await BlinkIDSDK.createIdBarcodeRecognizer(sdk);

  //     // [OPTIONAL] Create a callbacks object that will receive recognition events, such as detected object location etc.
  //     const callbacks = {
  //       onQuadDetection: (quad) => this.drawQuad(quad),
  //       onDetectionFailed: () =>
  //         this.updateScanFeedback(this.scanFeedbacktxt, true),
  //       // This callback is required for combined experience.
  //       onFirstSideResult: () => this.sucessfull(),
  //     };

  //     // 2. Create a RecognizerRunner object which orchestrates the recognition with one or more
  //     //    recognizer objects.
  //     const recognizerRunner = await BlinkIDSDK.createRecognizerRunner(
  //       // SDK instance to use
  //       this.sdk,
  //       // List of recognizer objects that will be associated with created RecognizerRunner object
  //       [combinedGenericIDRecognizer],
  //       // [OPTIONAL] Should recognition pipeline stop as soon as first recognizer in chain finished recognition
  //       false,
  //       // [OPTIONAL] Callbacks object that will receive recognition events
  //       callbacks
  //     );

  //     debugger;
  //     // 3. Create a VideoRecognizer object and attach it to HTMLVideoElement that will be used for displaying the camera feed
  //     const videoRecognizer =
  //       await BlinkIDSDK.VideoRecognizer.createVideoRecognizerFromCameraStream(
  //         this.cameraFeed,
  //         recognizerRunner
  //       );
  //     debugger;
  //     this.commonP.hideLoading();
  //     console.log("elihdvuihn");
  //     clearInterval(this.showHandle);
  //     this.showHandle = setInterval(() => {
  //       console.log("elihdvuihn 384783748");

  //       videoRecognizer?.releaseVideoFeed();
  //       recognizerRunner?.delete();
  //       combinedGenericIDRecognizer?.delete();
  //       document.getElementById("screen-start")?.classList.remove("hidden");
  //       document.getElementById("screen-scanning")?.classList.add("hidden");
  //       document.getElementById("show-upload-card")?.classList.remove("hidden");
  //       this.uploadCardImage();

  //       clearInterval(this.showHandle);
  //     }, this.config.BlinkTimeOut);
  //     const scanTimeoutSeconds = 15;

  //     // 4. Start the recognition and get results from callback

  //     debugger;
  //     console.log("dkuhu484444");

  //     console.log("dkuhu484444fefefe");
  //     await videoRecognizer.startRecognition(
  //       // 5. Obtain the results
  //       (recognitionState) => {
  //         debugger;
  //         console.log("dkuhu484444 hfiuh487");
  //         if (!videoRecognizer) {
  //           return;
  //         }

  //         // Pause recognition before performing any async operation
  //         videoRecognizer.pauseRecognition();
  //         if (recognitionState === BlinkIDSDK.RecognizerResultState.Empty) {
  //           return;
  //         }

  //         const resultdetaisl = combinedGenericIDRecognizer
  //           .getResult()
  //           .then(async (data) => {
  //             this.ValidIdCard = true;
  //             console.log(JSON.stringify(data), "IDCard Data");
  //             var result = data;
  //             await _self.ProcessResult(
  //               data,
  //               _self,
  //               videoRecognizer,
  //               recognizerRunner,
  //               combinedGenericIDRecognizer
  //             );
  //           });
  //       },
  //       scanTimeoutSeconds * 1000
  //     );
  //   }
  // }
  //Manual
  async startScan() {
    let _self = this;
    _self.Acceptcondition = false;
    //_self.livenessagree = false;
    _self.hidePopup();
    if (this.CardDocumentoption) {
      let get_id = document.getElementById("label-04") as HTMLInputElement;
      get_id.checked = true;
    }

    // 1. Create a recognizer objects which will be used to recognize single image or stream of images.
    //
    // Generic ID Recognizer - scan various ID documents
    // ID Barcode Recognizer - scan barcodes from various ID documents
    //const genericIDRecognizer = await BlinkIDSDK.createBlinkIdRecognizer(sdk);
    // if (FBLDevice.Environment.IsNative) {
    //   document.getElementById("show-upload-card")?.classList.add("hidden");

    //   // await this.commonP.presentLoading();
    //   //await this.getcountry();
    //   //await this.showPopup();

    //   //await this.commonP.hideLoading();
    //   // Start Identity Document Scanning on Native. Parameters (Mobile Number)

    //   FBLIdentityScanStartProxy({
    //     Mobile: this.auth.data.mobileNumber,
    //   });

    //   // Process Success Result for Identity Document Scanning

    //   FBL.Activities.IdentityScan.OnSuccess(async (result) => {
    //     //alert("Success");

    //     // console.log(result);
    //     this.ValidIdCard = true;
    //     // console.log(JSON.stringify(result), "IDCard Data");
    //     //   let checkdaa = JSON.parse(result);
    //     if (result) {
    //       //alert("Has data");
    //     } else {
    //       //alert("Has no data");
    //     }
    //     if (result.Response) {
    //       //alert("Has response object");
    //     } else {
    //       //alert("Has no response object");
    //     }
    //     await _self.ProcessResult(
    //       result.Response,
    //       _self,
    //       undefined,
    //       undefined,
    //       undefined
    //     );
    //     //success result from sdk
    //     // result contains the response from blinkId Identity scan.
    //   });

    //   // Process Fail Result for Identity Document Scanning

    //   FBL.Activities.IdentityScan.OnFailure(async (result) => {
    //     // alert("Failure");
    //     //alert("failed");
    //     //alert(JSON.stringify(result));

    //     // await _self.ProcessResult(
    //     //   result.Response,
    //     //   _self,
    //     //   undefined,
    //     //   undefined,
    //     //   undefined
    //     // );
    //     this.showPopup();
    //     // result contains details...
    //   });

    //   // Process System Errors for Identity Document Scanning

    //   FBL.Activities.IdentityScan.OnError(async (result) => {
    //     // alert("Error");
    //     //alert("Error");
    //     //alert(JSON.stringify(result));

    //     this.showPopup();
    //     // result contains details...
    //   });
    // } else {
    document.getElementById("screen-start")?.classList.add("hidden");
    document.getElementById("screen-scanning")?.classList.remove("hidden");

    const combinedGenericIDRecognizer =
      await BlinkIDSDK.createBlinkIdCombinedRecognizer(this.sdk);
    const settings = await combinedGenericIDRecognizer.currentSettings();
    settings["returnEncodedFaceImage"] = true;
    settings["returnEncodedFullDocumentImage"] = true;
    settings["returnEncodedSignatureImage"] = true;
    // settings["thoroughScanFromImage  "] = true;
    await combinedGenericIDRecognizer.updateSettings(settings);

    // const idBarcodeRecognizer = await BlinkIDSDK.createIdBarcodeRecognizer(sdk);

    // [OPTIONAL] Create a callbacks object that will receive recognition events, such as detected object location etc.
    const callbacks = {
      onQuadDetection: (quad) => this.drawQuad(quad),
      onDetectionFailed: () =>
        this.updateScanFeedback(this.scanFeedbacktxt, true),
      // This callback is required for combined experience.
      onFirstSideResult: () => this.sucessfull(),
    };

    // 2. Create a RecognizerRunner object which orchestrates the recognition with one or more
    //    recognizer objects.
    const recognizerRunner = await BlinkIDSDK.createRecognizerRunner(
      // SDK instance to use
      this.sdk,
      // List of recognizer objects that will be associated with created RecognizerRunner object
      [combinedGenericIDRecognizer],
      // [OPTIONAL] Should recognition pipeline stop as soon as first recognizer in chain finished recognition
      false,
      // [OPTIONAL] Callbacks object that will receive recognition events
      callbacks
    );

    debugger;
    // 3. Create a VideoRecognizer object and attach it to HTMLVideoElement that will be used for displaying the camera feed
    const videoRecognizer =
      await BlinkIDSDK.VideoRecognizer.createVideoRecognizerFromCameraStream(
        this.cameraFeed,
        recognizerRunner
      );
    debugger;
    this.commonP.hideLoading();
    console.log("elihdvuihn");
    clearInterval(this.showHandle);
    this.showHandle = setInterval(() => {
      console.log("elihdvuihn 384783748");

      videoRecognizer?.releaseVideoFeed();
      recognizerRunner?.delete();
      combinedGenericIDRecognizer?.delete();
      document.getElementById("screen-start")?.classList.remove("hidden");
      document.getElementById("screen-scanning")?.classList.add("hidden");
      document.getElementById("show-upload-card")?.classList.remove("hidden");
      this.uploadCardImage();

      clearInterval(this.showHandle);
    }, this.config.BlinkTimeOut);
    const scanTimeoutSeconds = 15;

    // 4. Start the recognition and get results from callback

    debugger;
    console.log("dkuhu484444");

    console.log("dkuhu484444fefefe");
    await videoRecognizer.startRecognition(
      // 5. Obtain the results
      (recognitionState) => {
        debugger;
        console.log("dkuhu484444 hfiuh487");
        if (!videoRecognizer) {
          return;
        }

        // Pause recognition before performing any async operation
        videoRecognizer.pauseRecognition();
        if (recognitionState === BlinkIDSDK.RecognizerResultState.Empty) {
          return;
        }

        const resultdetaisl = combinedGenericIDRecognizer
          .getResult()
          .then(async (data) => {
            this.ValidIdCard = true;
            console.log(JSON.stringify(data), "IDCard Data");
            var result = data;
            await _self.ProcessResult(
              data,
              _self,
              videoRecognizer,
              recognizerRunner,
              combinedGenericIDRecognizer
            );
          });
      },
      scanTimeoutSeconds * 1000
    );
    // }
  }

  dataURLtoBlob(dataurl) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }


  selection(key) {
    if (key == 0) {
      this.isfatherkey = true;
      this.ishusbandkey = false;
    } else {
      this.ishusbandkey = true;
      this.isfatherkey = false;
    }
  }
  handleClose() {
    this.videoRecognizer?.releaseVideoFeed();
    this.recognizerRunner?.delete();
    this.combinedGenericIDRecognizer?.delete();

    document.getElementById("screen-start")?.classList.remove("hidden");
    document.getElementById("screen-scanning")?.classList.add("hidden");
  }

  Permission() {
    var that = this;
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then(function (stream) {
        that.localstream = stream;
        stream.getVideoTracks().forEach(function (track) {
          track.stop();
        });
        that.ScanView = false;
      })
      .catch(function (err) {
        that.commonP.ParseErrorAlert(
          "Sorry",
          "OK",
          that._router,
          "Your device does not support this feature"
        );
        that.ScanView = true;
      });
  }

  /**
   * Scan single side of identity document with web camera.
   */
  showfronterror: boolean = false;
  showbackerror: boolean = false;

  async startCardimage(sdk) {
    //clearTimeout(this.showHandle);
    // 1. Create a recognizer objects which will be used to recognize single image or stream of images.
    //
    // GenericCombine ID Recognizer - scan ID documents on both sides
    const combinedGenericIDRecognizer =
      await BlinkIDSDK.createBlinkIdCombinedRecognizer(sdk);

    // [OPTIONAL] Proceed with scanning the back side even if the front side result is uncertain.
    const settings = await combinedGenericIDRecognizer.currentSettings();

    settings.returnEncodedFaceImage = true;
    settings.returnEncodedFullDocumentImage = true;
    settings.returnEncodedSignatureImage = true;
    //settings.thoroughScanFromImage
    await combinedGenericIDRecognizer.updateSettings(settings);

    // 2. Create a RecognizerRunner object which orchestrates the recognition with one or more
    //    recognizer objects.
    const recognizerRunner = await BlinkIDSDK.createRecognizerRunner(
      // SDK instance to use
      sdk,
      // List of recognizer objects that will be associated with created RecognizerRunner object
      [combinedGenericIDRecognizer],
      // [OPTIONAL] Should recognition pipeline stop as soon as first recognizer in chain finished recognition
      false
    );

    // 3. Prepare front side image for scan action - keep in mind that SDK can only process images represented
    //    in internal CapturedFrame data structure. Therefore, auxiliary method "captureFrame" is provided.

    // Make sure that image file is provided

    const fileFrontSide = await this.getImageFromInput(
      this.inputImageFileFrontSide.files
    );

    console.log(fileFrontSide, "fileFrontSide");
    if (!fileFrontSide) {
      var text = "Please reupload the front side of your ID card";
      this.uploadCardImageError(text);
      // Release memory on WebAssembly heap used by the RecognizerRunner
      recognizerRunner?.delete();

      // Release memory on WebAssembly heap used by the recognizer
      combinedGenericIDRecognizer?.delete();
      this.inputImageFileFrontSide.value = "";
      return;
    }

    const imageFrame = await this.getImageFrame(fileFrontSide, "Front");
    console.log(imageFrame, "imageFrame");
    // 4. Start the recognition and await for the results
    const processResultFrontSide = await recognizerRunner.processImage(
      imageFrame
    );

    // 5. If recognition of the first side was successful, process the back side
    if (processResultFrontSide !== BlinkIDSDK.RecognizerResultState.Empty) {
      // 6. Prepare back side image for scan action
      const fileBackSide = this.getImageFromInput(
        this.inputImageFileBackSide.files
      );

      if (!fileBackSide) {
        var text = "Please reupload the back side of your ID card";
        this.uploadCardImageError(text);
        // Release memory on WebAssembly heap used by the RecognizerRunner
        recognizerRunner?.delete();

        // Release memory on WebAssembly heap used by the recognizer
        combinedGenericIDRecognizer?.delete();
        this.inputImageFileBackSide.value = "";
        return;
      }
      var _self = this;
      const imageFrame = await this.getImageFrame(fileBackSide, "Back");

      // 7. Start the recognition and await for the results
      const processResultBackSide = await recognizerRunner.processImage(
        imageFrame
      );

      if (processResultBackSide !== BlinkIDSDK.RecognizerResultState.Empty) {
        // 8. If recognition of the back side was successful, obtain the result and display it
        // const results = await combinedGenericIDRecognizer.getResult();
        try {
          const resultdetaisl = await combinedGenericIDRecognizer
            .getResult()
            .then(async (data) => {
              this.ValidIdCard = true;
              console.log(data, "data");
              var result = data;
              if (result) {
                _self.nicoptype = false;
                _self.cnictype = false;

                var encodedfaceImage = result.faceImage.encodedImage;
                var faceSuccessfulImage = _self.Uint8ToBase64(encodedfaceImage);

                if (this.frontimagebase64) {
                  _self.dataCaptured = true;
                  // Front image
                  var docImage = this.frontimagebase64;
                  if (docImage) {
                    _self.front = _self.Sanitizer.bypassSecurityTrustUrl(
                      "data:image/jpg;base64, " + docImage
                    );
                    _self.frontBlob = _self.dataURLtoBlob(
                      "data:image/jpg;base64, " + docImage
                    );
                    _self.auth.registrationfblObject.frontCardImage = docImage;
                    _self.frontHide = "1";
                    _self.frontsuccess = true;
                  }
                  // back image
                  var backImage = this.backimagebase64;
                  if (backImage) {
                    _self.back = _self.Sanitizer.bypassSecurityTrustUrl(
                      "data:image/jpg;base64, " + backImage
                    );
                    _self.backBlob = _self.dataURLtoBlob(
                      "data:image/jpg;base64, " + backImage
                    );
                    _self.auth.registrationfblObject.backCardImage = backImage;
                    _self.frontHide = "1";
                    _self.frontsuccess = true;
                  }
                  // Face image
                  var faceimage = faceSuccessfulImage;
                  if (faceimage) {
                    _self.face = _self.Sanitizer.bypassSecurityTrustUrl(
                      "data:image/jpg;base64, " + faceimage
                    );
                    _self.faceBlob = _self.dataURLtoBlob(
                      "data:image/jpg;base64, " + faceimage
                    );
                    _self.auth.registrationfblObject.personFaceImage =
                      faceimage;
                    _self.frontHide = "1";
                    _self.faceimage = true;
                  }

                  var fields = result.mrz;
                  if (fields.parsed == false) {
                    var visualData = result.frontViz;
                    var countryClass = result.classInfo.country;
                    let issuer = _self.country.countries.find(
                      (x) => x.blinkCode == countryClass
                    );
                    if (issuer) {
                      var name: string[] = [];

                      var middleName = "";
                      var familyName = "";
                      var fullName = "";

                      name = visualData.fullName.split(" ");

                      for (var i = 1; i < name.length - 1; i++) {
                        middleName = middleName + " " + name[i];
                      }
                      debugger;
                      familyName = name[name.length - 1];
                      fullName = visualData.fullName;

                      _self.auth.registrationfblObject.issuer = issuer.isoCode3;
                      _self.auth.registrationfblObject.nationality =
                        issuer.isoCode3;
                      _self.auth.registrationfblObject.familyName =
                        familyName.trim();
                      _self.auth.registrationfblObject.middleName = middleName
                        ? middleName.trim()
                        : "";

                      _self.auth.registrationfblObject.firstName =
                        name[0].trim();

                      _self.auth.registrationfblObject.documentNumber =
                        visualData.personalIdNumber
                          ? visualData.personalIdNumber
                            .replace(/-/g, "")
                            .replace(/</g, "")
                            .replace(/O/g, "0")
                            .replace(/o/g, "0")
                            .replace(/l/g, "1")
                          : visualData.documentNumber
                            .replace(/-/g, "")
                            .replace(/</g, "")
                            .replace(/O/g, "0")
                            .replace(/o/g, "0")
                            .replace(/l/g, "1");

                      _self.auth.registrationfblObject.documentCode = "I";
                      _self.auth.registrationfblObject.countryID =
                        issuer.isoCode3;

                      _self.auth.registrationfblObject.dOB =
                        result.dateOfBirth.month +
                        "/" +
                        result.dateOfBirth.day +
                        "/" +
                        result.dateOfBirth.year;
                      _self.auth.registrationfblObject.issuedate =
                        result.dateOfIssue.month +
                        "/" +
                        result.dateOfIssue.day +
                        "/" +
                        result.dateOfIssue.year;
                      _self.auth.registrationfblObject.IsLifeTimeCnic =
                        result.dateOfExpiryPermanent
                          ? result.dateOfExpiryPermanent
                          : false;
                      debugger;
                      if (result.dateOfExpiry) {
                        _self.auth.registrationfblObject.dOE =
                          result.dateOfExpiry.month +
                          "/" +
                          result.dateOfExpiry.day +
                          "/" +
                          result.dateOfExpiry.year;
                        _self.auth.registrationfblObject.dOI =
                          result.dateOfIssue.month +
                          "/" +
                          result.dateOfIssue.day +
                          "/" +
                          result.dateOfIssue.year;

                        if (!_self.auth.registrationfblObject.IsLifeTimeCnic) {
                          if (_self.auth.registrationfblObject.dOE == "0/0/0") {
                            _self.auth.registrationfblObject.dOE =
                              result.dateOfExpiry.month +
                              "/" +
                              result.dateOfExpiry.day +
                              "/" +
                              result.dateOfExpiry.year;
                          }
                        }

                        if (_self.auth.registrationfblObject.dOI == "0/0/0") {
                          _self.auth.registrationfblObject.dOI =
                            result.dateOfIssue.month +
                            "/" +
                            result.dateOfIssue.day +
                            "/" +
                            result.dateOfIssue.year;
                        }
                      } else {
                      }
                      _self.IslifeTime =
                        _self.auth.registrationfblObject.IsLifeTimeCnic;

                      if (_self.IslifeTime) {
                        _self.showdoe = false;
                      } else {
                        _self.IsNotlifeTime = true;
                        _self.showdoe = true;
                        _self.DoedaySelect = result.dateOfExpiry.day.toString();
                        _self.DoeMonthSelect =
                          result.dateOfExpiry.month.toString();
                        _self.DoeYearSelect =
                          result.dateOfExpiry.year.toString();
                      }
                      _self.ScanType = "I";
                      console.log(_self.auth.registrationfblObject);
                    } else {
                    }
                    debugger;
                    _self.FirstName =
                      _self.auth.registrationfblObject?.firstName;
                    _self.MiddleName =
                      _self.auth.registrationfblObject?.middleName;
                    _self.LastName =
                      _self.auth.registrationfblObject?.familyName;
                    _self.FatherName =
                      _self.auth.registrationObject?.FatherName;
                    _self.IDNumber =
                      _self.auth.registrationfblObject?.documentNumber;

                    if (visualData.sex) {
                      if (visualData.sex == "M") {
                        debugger;
                        let accountType = await this.commonP.Get("accountType");

                        if (accountType == 'A') {

                          this.translate
                            .get(["Sorry", "err-amalRestriction", "OK"])
                            .subscribe((data) => {
                              this.commonP
                                .showErrorAlert(
                                  data["Sorry"],
                                  data["err-amalRestriction"],
                                  data["OK"],
                                  this._router
                                )
                                .then((data: any) => { });
                            });



                          this._router.navigateByUrl("/MobileVerification");

                        }
                        else {

                          _self.auth.registrationfblObject.gender =
                            visualData.sex;
                          _self.Gender = "Male";
                          _self.ValidGender = true;
                        }


                      } else if (visualData.sex == "F") {
                        _self.auth.registrationfblObject.gender =
                          visualData.sex;
                        _self.Gender = "Female";

                        _self.ValidGender = true;
                      }
                    } else {
                      if (_self.IDNumber) {
                        let lastdigit = Number(_self.IDNumber) % 10;
                        if (lastdigit % 2 == 0) {
                          _self.auth.registrationfblObject.gender =
                            visualData.sex;
                          _self.Gender = "Female";
                          _self.ValidGender = true;
                          this.commonP.Set("IDGendertype", _self.Gender);
                        } else {
                          _self.auth.registrationfblObject.gender =
                            visualData.sex;
                          _self.Gender = "Male";
                          this.commonP.Set("IDGendertype", _self.Gender);
                          _self.ValidGender = true;
                        }
                      }
                    }

                    _self.DobdaySelect = result.dateOfBirth.day.toString();
                    console.log(_self.DobdaySelect, "Value");
                    console.log("ARRAY", this.dobdayslistArray);

                    _self.DobMonthSelect = result.dateOfBirth.month.toString();
                    _self.DobYearSelect = result.dateOfBirth.year.toString();

                    _self.issuedaySelect = result.dateOfIssue.day.toString();
                    _self.issueMonthSelect =
                      result.dateOfIssue.month.toString();
                    _self.issueYearSelect = result.dateOfIssue.year.toString();

                    // _self.cnictype = true;
                    // _self.IDtype = "CNIC";

                    if (_self.FirstName && _self.LastName) {
                      _self.snictype = true;
                      _self.cnictype = false;
                      _self.IDtype = "SNIC";
                    } else {
                      _self.cnictype = true;
                      _self.snictype = false;
                      _self.IDtype = "CNIC";
                    }

                    _self.ScanID = true;
                    _self.showscanid = true;
                    _self.Selfiescan = true;
                    _self.commonP.hideLoading();
                    // _self.Selfie()
                  } else {
                    _self.commonP.hideLoading();
                    _self.translate
                      .get(["Sorry", "MRZcardnotallowed", "OK"])
                      .subscribe((data) => {
                        _self.commonP
                          .showErrorAlert(
                            data.Sorry,
                            data.MRZcardnotallowed,
                            data.OK,
                            _self._router
                          )
                          .then(async (res) => {
                            if (res == "Ok") {
                              await _self.startScan();
                            }
                          });
                      });
                  }
                }
                _self.commonP.hideLoading();
                console.log("evjlnven delete");
                // Release memory on WebAssembly heap used by the RecognizerRunner
                recognizerRunner?.delete();
                console.log("evjlnven delete 21");
                // Release memory on WebAssembly heap used by the recognizer
                combinedGenericIDRecognizer?.delete();
                // Hide scanning screen and show scan button again
                this.inputImageFileFrontSide.value = "";
                this.inputImageFileBackSide.value = "";
                document
                  .getElementById("screen-start")
                  ?.classList.remove("hidden");
                document
                  .getElementById("screen-scanning")
                  ?.classList.add("hidden");
                document
                  .getElementById("show-upload-card")
                  ?.classList.add("hidden");
                _self.ValidIdCard = true;
              } else {
                _self.commonP.hideLoading();
                _self.front = "./assets/images/TapFront.gif";
                _self.frontHide = "1";
                _self.backHide = "";
                _self.back = "";
              }
            });
        } catch (error) {
          console.error(
            "Error during initialization of VideoRecognizer:",
            error
          );
          return;
        }
      } else {
        var text =
          "Could not extract information from the back side of a document!";
        this.uploadCardImageError(text);
      }
    } else {
      var text =
        "Could not extract information from the front side of a document!";
      this.uploadCardImageError(text);
    }

    // 9. Release all resources allocated on the WebAssembly heap and associated with camera stream
  }

  getImageFromInput(fileList) {
    let image = null;
    const imageRegex = RegExp(/^image\//);
    for (let i = 0; i < fileList.length; ++i) {
      if (imageRegex.exec(fileList[i].type)) {
        image = fileList[i];
      }
    }
    return image;
  }

  getcountry() {
    this.commonP.presentLoading();
    this.country.GetAll(Guid.create().toString()).then(async (data: any) => {
      if (data.response) {
        if (data.response.code) {
          if (data.response.code == 1) {
            this.commonP.hideLoading();
            this.country.countries = data.response.content;
          }
        }
      }
    });
  }

  getMessage(key, control) {
    let error = "";
    this.translate.get([key]).subscribe((data) => {
      error = data[key];
    });
    return error;
  }

  public get triggerObservable(): Observable<void> {
    if (this.cameraactive) {
      return this.trigger.asObservable();
    }
  }

  showPopup1() {
    this.checkCamera();
    this.hidePopup4();
  }
  localstream;
  checkCamera() {
    var that = this;
    that.commonP.presentLoading();
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then(function (stream) {
        that.localstream = stream;
        that.cameraactive = true;
        that.renderer.addClass(that.Modal2.nativeElement, "active");
        that.commonP.hideLoading();
      })
      .catch(function (err) {
        that.commonP.hideLoading();
        that.translate
          .get(["Cameraunavailable", "cameracheck", "OK"])
          .subscribe((data) => {
            that.commonP.ParseErrorAlert(
              data.Cameraunavailable,
              data.OK,
              that._router,
              data.cameracheck
            );
          });
        that.cameraactive = false;
      });
  }

  hidePopup1() {
    this.renderer.removeClass(this.Modal2.nativeElement, "active");
    this.cameraactive = false;
    this.localstream.getTracks()[0].stop();
  }

  // hidePopup3() {
  //   this.translate
  //     .get(["Verify", "Cancel", "NewDeviceMSG"])
  //     .subscribe(async (data) => {
  //       this.commonP
  //         .showTwoButtonAlert(
  //           "Confirmation",
  //           "message",
  //           [data["Cancel"], data["Verify"]],
  //           this._router
  //         )
  //         .then((data) => {
  //           if (data == "Verify") {

  //           } else {
  //             this.CampTempimag = [];
  //             this.renderer.removeClass(this.Modal3.nativeElement, "active");
  //             this.showPopup1();
  //           }
  //         });
  //     });
  // }

  async selfiedone() {
    this.renderer.removeClass(this.Modal3.nativeElement, "active");
    this.localstream.getTracks()[0].stop();

    this.selfieimg = this.CampTempimag.find((o) => o.Key === 0)?.value;
    await this.AcuantOperation();
  }



  async retake() {
    this.CampTempimag = [];
    this.Acceptcondition = false;
    // this.livenessagree = false;

    this.renderer.removeClass(this.Modal3.nativeElement, "active");

    this.showPopup1();
  }

  removeImage3() {
    this.renderer.setAttribute(this.imagetag2.nativeElement, "src", "");
    this.CameraViewer = false;
    this.CampTempimag = [];
    this.renderer.removeClass(this.Modal3.nativeElement, "active");
  }

  showPopup3(key) {
    if (this.CampTempimag) {
      this.selfieimg = this.CampTempimag.find((o) => o.Key === key)?.value;
      this.renderer.setAttribute(
        this.imagetag2.nativeElement,
        "src",
        this.selfieimg
      );
      this.renderer.addClass(this.Modal3.nativeElement, "active");
    }
  }

  isFormValid() {
    debugger
    if (!this.RegistrationForm.valid) {
      return true;
    } else {
      if (this.front && this.back) {
        if (this.cnictype == false && this.snictype == false) {
          return true;
        }
        if (this.IslifeTime == false && this.IsNotlifeTime == false) {
          return true;
        }
        if (this.IslifeTime) {
          return false;
        } else {
          if (this.DoedaySelect && this.DoeMonthSelect && this.DoeYearSelect) {
          } else {
            return true;
          }
          if (this.Gender) {
            return false;
          }

          return true;
        }
      } else {
        return true;
      }
    }
  }
  onChange(d) {
    this.auth.registrationfblObject.gender = d
  }
  async SaveRegistrationInfo() {
    debugger
    let obj = this.auth.registrationfblObject;

    let mobileNumber = await this.commonP.Get("mobilenumber");
    let AccountType: string = await this.commonP.Get("accountType");
    // obj.accountType = AccountType != null && AccountType != undefined && AccountType != "" ? AccountType : "I";
    obj.mobileNumber = mobileNumber;
    let id = Guid.create();
    obj.UniqueId = id.toString();

    obj.Latitude = this.commonP.latitiude;
    obj.Longitude = this.commonP.longitude;

    obj.firstName = this.RegistrationForm.get("FirstName").value;
    obj.middleName = this.RegistrationForm.get("MiddleName").value;
    obj.gender = this.RegistrationForm.get("Gender").value;
    obj.familyName = this.RegistrationForm.get("LastName").value;
    obj.fatherName = this.RegistrationForm.get("FatherName").value;
    obj.IsFatherName = this.isfatherkey;


    obj.ResidenceCountry = "PAK";

    let middleName = this.RegistrationForm.get("MiddleName").value
      ? this.RegistrationForm.get("MiddleName").value
      : "";

    if (middleName) {
      obj.FullName =
        this.RegistrationForm.get("FirstName").value +
        " " +
        middleName +
        " " +
        this.RegistrationForm.get("LastName").value;
    } else {
      obj.FullName =
        this.RegistrationForm.get("FirstName").value +
        " " +
        this.RegistrationForm.get("LastName").value;
    }

    obj.cardtype = this.IDtype;
    //obj.selfieimage = this.imagebase64;
    obj.dOB =
      this.DobMonthSelect + "/" + this.DobdaySelect + "/" + this.DobYearSelect;
    obj.dOI =
      this.issueMonthSelect +
      "/" +
      this.issuedaySelect +
      "/" +
      this.issueYearSelect;
    obj.issuedate = obj.dOI;

    if (this.IslifeTime) {
    } else {
      obj.dOE =
        this.DoeMonthSelect +
        "/" +
        this.DoedaySelect +
        "/" +
        this.DoeYearSelect;
    }
    console.log(this.auth.registrationfblObject.dOE);
    console.log(this.auth.registrationfblObject.dOB);
    console.log(this.auth.registrationfblObject.dOI);
    if (this.isManual) {
      // alert("Manual");
      debugger


      obj.documentCode = "I";
      obj.countryID = "PAK";
      obj.issuer = "PAK";
      obj.nationality = "PAK";

      console.log("manualkeander", this.IDNumber);

    }
    obj.documentNumber = this.IDNumber;
  }
  getText() {
    if (this.isManual) {
      return "Upload";
    } else {
      return "Scanidcard";
    }
  }
  SaveIdCardUpdateInfo() {
    debugger;
    var object = this.auth.IdCardObject;
    object.cardtype = this.IDtype;
    // object.selfieimage = this.imagebase64;
    // object.dOB = this.auth.registrationfblObject?.dOB;
    // object.issuedate = this.auth.registrationfblObject?.issuedate;
    object.dOB =
      this.DobMonthSelect + "/" + this.DobdaySelect + "/" + this.DobYearSelect;
    object.issuedate =
      this.issueMonthSelect +
      "/" +
      this.issuedaySelect +
      "/" +
      this.issueYearSelect;
    //object.dO=obj.dOI;

    if (this.IslifeTime) {
    } else {
      object.dOE =
        this.DoeMonthSelect +
        "/" +
        this.DoedaySelect +
        "/" +
        this.DoeYearSelect;
    }
    object.gender = this.RegistrationForm.get("Gender").value;
    object.firstName = this.RegistrationForm.get("FirstName").value;
    object.middleName = this.RegistrationForm.get("MiddleName").value;
    object.familyName = this.RegistrationForm.get("LastName").value;
    object.fatherName = this.RegistrationForm.get("FatherName").value;
    object.IsFatherName = this.isfatherkey;

    let middleName = this.RegistrationForm.get("MiddleName").value
      ? this.RegistrationForm.get("MiddleName").value
      : "";
    if (middleName) {
      object.fullName =
        this.RegistrationForm.get("FirstName").value +
        " " +
        middleName +
        " " +
        this.RegistrationForm.get("LastName").value;
    } else {
      object.fullName =
        this.RegistrationForm.get("FirstName").value +
        " " +
        this.RegistrationForm.get("LastName").value;
    }

    object.documentCode = "Id";
    if (this.isManual) {
      if (this.showdoe) {
        object.IsLifeTimeCnic = this.auth.IdCardObject?.IsLifeTimeCnic;
        object.dOE = this.auth.IdCardObject?.dOE;
      } else {
        object.IsLifeTimeCnic = this.auth.IdCardObject?.IsLifeTimeCnic;
      }
    } else {
      if (this.showdoe) {
        object.IsLifeTimeCnic = this.auth.registrationfblObject?.IsLifeTimeCnic;
        object.dOE = this.auth.registrationfblObject?.dOE;
      } else {
        object.IsLifeTimeCnic = this.auth.registrationfblObject?.IsLifeTimeCnic;
      }
    }

    object.frontCardImage = this.auth.registrationfblObject?.frontCardImage
      ? this.auth.registrationfblObject?.frontCardImage
      : "";
    object.backCardImage = this.auth.registrationfblObject?.backCardImage
      ? this.auth.registrationfblObject?.backCardImage
      : "";

    object.documentNumber = this.auth.registrationfblObject?.documentNumber;
    object.gender = this.Gender;

    object.issuer = "PAK";
    object.mrtDraw = "";
    object.optionalData1 = "";
    object.optionalData2 = "";
    object.fireBaseToken = "";
    object.companyId = 1;

    object.countryID = "PAK";
    object.nationality = "PAK";

    // if (this.loginresponse.occupation == "Housewife / Household") {
    //   object.type = "G";
    // } else {
    object.type = "C";
    // }
    if (this.isManual) {
      // alert("Manual");

      object.documentCode = "I";
      object.countryID = "PAK";
      object.issuer = "PAK";
      object.nationality = "PAK";
      object.documentNumber = this.IDNumber;
    }
  }

  async RegisterUser() {
    debugger;
    if (this.isMinorFlow) {

      if (this.kyc.IDCardexpire != "Card-Expire") {
        this.commonP.presentLoading();
        this.SaveIdCardUpdateInfo();
        this.auth.IdCardObject.type = "G";
        //this.auth.IdCardObject.facialtransactionid=this.fa  
        console.log("Selfie id", this.auth.IdCardObject.facialtransactionid);
        console.log("Selfie id1", this.auth.IdCardObject.selfietransactionid);


        this.auth.accessToken = await this.auth.Get("token");

        await this.auth
          .RegisterGuardian(
            this.auth.accessToken,
            this.auth.IdCardObject,
            this.isManual
          )
          .then((data: any) => {
            if (data?.response?.code == 1) {
              this.commonP.Set("User", JSON.stringify(this.loginresponse));
              this.commonP.Set("token", data.response.token);
              this.kyc.count = 0;

              this.kyc
                .GetKycStatus(
                  this.auth.accessToken,
                  this.loginresponse.onBoardingAccount &&
                    this.loginresponse.applicationId
                    ? this.loginresponse.onBoardingAccount.productId
                    : 60
                )
                .then(async (data: any) => {
                  if (data?.response?.code == 1) {
                    if (this.kyc.totalCount > 0) {
                      let nextscreen = this.kyc.getScreen(this.kyc.count);

                      this._router.navigateByUrl(nextscreen);
                      this.commonP.hideLoading();
                    } else {
                      this.commonP.ParseErrorAlert("", "", this._router, data);
                    }
                  } else {
                    this.commonP.ParseErrorAlert("", "", this._router, data);
                  }
                });
            } else {
              this.commonP.hideLoading();
              this.commonP.parseError(data).then((mes) => {
                this.translate.get(["Sorry", "Ok"]).subscribe((data) => {
                  this.commonP
                    .showErrorAlert(data["Sorry"], mes, data["Ok"], this._router)
                    .then((res) => {
                      if (res == Config.OK) {
                        this.ScanID = false;
                        this.CampTempimag = [];
                        this.selfieimg = null;
                        this.isImageSaved1 = false;
                        this.isImageSaved = false;
                        this.frontcardImageBase64 = "";
                        this.frontimage64 = "";
                        this.frontimagebase64 = "";
                        this.frontimagebase641 = "";
                        this.AttachImage = false;
                        this.isImageSaved = false;
                        this.AttachImage1 = false;
                        this.isImageSaved1 = false;

                        document
                          .getElementById("screen-start-front")
                          ?.classList.remove("hidden");
                        document.getElementById("start-front")?.classList.remove("hidden");



                        document
                          .getElementById("screen-start-back")
                          ?.classList.remove("hidden");
                        document.getElementById("start-back")?.classList.remove("hidden");


                        if (this.isManual) {
                        } else {
                          ///TOberemoved
                          this.UserRegister = false;
                          // this.renderer.removeChild(
                          //  this.elementRef.nativeElement,
                          //  this.script
                          //);

                          this.IDCard();
                        }
                      }
                    });
                });
              });
            }
          });
        // this._router.navigateByUrl("/register/Validatethedetails");
      } else {
        this.commonP.presentLoading();
        this.SaveIdCardUpdateInfo();
        this.auth.IdCardObject.type = "G";
        this.auth.IdCardObject.journeyId = this.auth.registrationfblObject.journeyId
        this.auth.accessToken = await this.auth.Get("token");
        debugger
        //  let AccountType:string = await this.commonP.Get("accountType");
        // this.auth.IdCardObject.accountType = AccountType ?? "I"



        await this.auth
          .SaveIdCard(
            this.auth.accessToken,
            this.auth.IdCardObject,
            this.isManual
          )
          .then((data: any) => {
            if (data?.response?.code == 1) {
              this.commonP.Set("User", JSON.stringify(this.loginresponse));
              this.commonP.Set("token", data.response.token);
              this.kyc.count = 0;

              this.kyc
                .GetKycStatus(
                  this.auth.accessToken,
                  this.loginresponse.onBoardingAccount &&
                    this.loginresponse.applicationId
                    ? this.loginresponse.onBoardingAccount.productId
                    : 60
                )
                .then(async (data: any) => {
                  if (data?.response?.code == 1) {
                    if (this.kyc.totalCount > 0) {
                      let nextscreen = this.kyc.getScreen(this.kyc.count);

                      this._router.navigateByUrl(nextscreen);
                      this.commonP.hideLoading();
                    } else {
                      this.commonP.ParseErrorAlert("", "", this._router, data);
                    }
                  } else {
                    this.commonP.ParseErrorAlert("", "", this._router, data);
                  }
                });
            } else {
              this.commonP.hideLoading();
              this.commonP.parseError(data).then((mes) => {
                this.translate.get(["Sorry", "Ok"]).subscribe((data) => {
                  this.commonP
                    .showErrorAlert(data["Sorry"], mes, data["Ok"], this._router)
                    .then((res) => {
                      if (res == Config.OK) {
                        this.ScanID = false;
                        this.CampTempimag = [];
                        this.selfieimg = null;
                        this.isImageSaved1 = false;
                        this.isImageSaved = false;
                        this.frontcardImageBase64 = "";
                        this.frontimage64 = "";
                        this.frontimagebase64 = "";
                        this.frontimagebase641 = "";
                        this.AttachImage = false;
                        this.isImageSaved = false;
                        this.AttachImage1 = false;
                        this.isImageSaved1 = false;

                        document
                          .getElementById("screen-start-front")
                          ?.classList.remove("hidden");
                        document.getElementById("start-front")?.classList.remove("hidden");



                        document
                          .getElementById("screen-start-back")
                          ?.classList.remove("hidden");
                        document.getElementById("start-back")?.classList.remove("hidden");

                        if (this.isManual) {
                        } else {
                          ///TOberemoved
                          this.UserRegister = false;
                          // this.renderer.removeChild(
                          //  this.elementRef.nativeElement,
                          //  this.script
                          //);

                          this.IDCard();
                        }
                      }
                    });
                });
              });
            }
          });
      }


    } else {
      if (this.kyc.IDCardexpire != "Card-Expire") {

        await this.commonP.presentLoading();


        await this.SaveRegistrationInfo();


        this.auth.registrationfblObject.CountryName = "";
        //this.auth.registrationfblObject.Longitude = "";
        //this.auth.registrationfblObject.Latitude = "";
        this.auth.registrationfblObject.Ip = "";
        this.auth.registrationfblObject.City = "";
        this.auth.registrationfblObject.CountryCode = "";
        // this.auth.registrationfblObject.del=  this.auth.GeoData.geoplugin_delay;
        this.auth.registrationfblObject.RegionCode = "";
        this.auth.registrationfblObject.Region = "";
        this.auth.registrationfblObject.ContinentName = "";
        this.auth.registrationfblObject.RegionName = "";
        this.auth.registrationfblObject.TimeZone = "";
        this.DoRegistration();
        // this._router.navigateByUrl("/register/Validatethedetails");
      } else {
        this.UserRegister = true;
        this.Selfiescan = false;

        this.commonP.presentLoading();
        this.SaveIdCardUpdateInfo();
        this.auth.accessToken = await this.auth.Get("token");
        this.auth.IdCardObject.journeyId = this.auth.registrationfblObject.journeyId
        await this.auth
          .SaveIdCard(
            this.auth.accessToken,
            this.auth.IdCardObject,
            this.isManual
          )
          .then((data: any) => {
            if (data?.response?.code == 1) {
              this.commonP.Set("User", JSON.stringify(this.loginresponse));
              this.commonP.Set("token", data.response.token);
              this.kyc.count = 0;

              this.kyc
                .GetKycStatus(
                  this.auth.accessToken,
                  this.loginresponse.onBoardingAccount &&
                    this.loginresponse.applicationId
                    ? this.loginresponse.onBoardingAccount.productId
                    : 36
                )
                .then(async (data: any) => {
                  if (data?.response?.code == 1) {
                    if (this.kyc.totalCount > 0) {
                      let nextscreen = this.kyc.getScreen(this.kyc.count);

                      this.ngZone.run(() => {

                        this._router.navigateByUrl(nextscreen);

                      });

                      this.commonP.hideLoading();


                    } else {
                      this.commonP.ParseErrorAlert("", "", this._router, data);
                    }
                  } else {
                    this.commonP.ParseErrorAlert("", "", this._router, data);
                  }
                });
            } else {
              this.commonP.hideLoading();
              this.commonP.parseError(data).then((mes) => {
                this.translate.get(["Sorry", "Ok"]).subscribe((data) => {
                  this.commonP
                    .showErrorAlert(data["Sorry"], mes, data["Ok"], this._router)
                    .then((res) => {
                      if (res == Config.OK) {
                        this.ScanID = false;
                        this.CampTempimag = [];
                        this.selfieimg = null;
                        this.isImageSaved1 = false;
                        this.isImageSaved = false;
                        this.frontcardImageBase64 = "";
                        this.frontimage64 = "";
                        this.frontimagebase64 = "";
                        this.frontimagebase641 = "";
                        this.AttachImage = false;
                        this.isImageSaved = false;
                        this.AttachImage1 = false;
                        this.isImageSaved1 = false;

                        document
                          .getElementById("screen-start-front")
                          ?.classList.remove("hidden");
                        document.getElementById("start-front")?.classList.remove("hidden");



                        document
                          .getElementById("screen-start-back")
                          ?.classList.remove("hidden");
                        document.getElementById("start-back")?.classList.remove("hidden");

                        if (this.isManual) {
                        } else {
                          ///TOberemoved
                          this.UserRegister = false;
                          // this.renderer.removeChild(
                          //  this.elementRef.nativeElement,
                          //  this.script
                          //);

                          this.IDCard();
                        }
                      }
                    });
                });
              });
            }
          });
      }
    }

  }
  async DoRegistration() {
    this.auth.registrationfblObject.Latitude = this.commonP.latitiude;
    this.auth.registrationfblObject.Longitude = this.commonP.longitude;

    // for getting accountType fahad bhai kamal

    let AccountType = await this.commonP.Get("accountType");
    //var _self = this;
    this.auth.registrationfblObject.accountType = AccountType;
    console.log('accountType', this.auth.registrationfblObject.accountType);
    console.log(
      "lifetime panga",
      this.auth.registrationfblObject.IsLifeTimeCnic
    );
    this.auth.Register(this.isManual).then(async (data: any) => {


      if (data?.response?.code == 1) {
        await this.commonP.hideLoading();

        this.ngZone.run(() => {
          this._router.navigateByUrl("/register/AccountType");
        });

      } else {
        await this.commonP.hideLoading();

        // this.commonP.ParseErrorAlert("", "", this._router, data);

        this.commonP.parseError(data).then((mes) => {
          this.translate.get(["Sorry", "Ok"]).subscribe((data) => {
            this.commonP
              .showErrorAlert(data["Sorry"], mes, data["Ok"], this._router)
              .then((res) => {
                if (res == Config.OK) {
                  this.ScanID = false;
                  this.CampTempimag = null;
                  this.selfieimg = null;

                  if (this.isManual) {
                  } else {
                    ///TOberemoved
                    this.UserRegister = false;
                    // this.renderer.removeChild(
                    //   this.elementRef.nativeElement,
                    //   this.script
                    // );

                    this.IDCard();
                  }
                }
              });
          });
        });
      }
    });
  }
  retryscan() {
    this.UserRegister = false;
    this.CampTempimag = [];
    this.selfieimg = null;
    this.commonP.presentLoading();
    this.auth.CleanregistrationfblObject();
    this.renderer.removeClass(this.modalAttachfront.nativeElement, "active");
    this.frontimagebase64 = "";
    this.frontimagebase641 = "";
    this.AttachImage = false;
    this.isImageSaved = false;
    this.showscanid = false;
    this.ScanID = false;
    this.auth.CleanregistrationfblObject();
    this.clearForm();
    this.inputImageFileFrontSide.value = "";
    document.getElementById("screen-start-front")?.classList.remove("hidden");

    this.renderer.removeClass(this.modalAttachback.nativeElement, "active");
    this.backimagebase64 = "";
    this.backimagebase641 = "";
    this.AttachImage1 = false;
    this.isImageSaved1 = false;
    this.showscanid = false;
    this.ScanID = false;
    this.auth.CleanregistrationfblObject();
    this.clearForm();
    this.inputImageFileBackSide.value = "";
    document.getElementById("screen-start-back")?.classList.remove("hidden");
    // this.renderer.removeChild(this.elementRef.nativeElement, this.script);

    this.IDCard();
  }

  hidePopup() {
    let get_id = document.getElementById("label-04") as HTMLInputElement;
    if (get_id) {
      get_id.checked = false;
    }
    this.ValidIdCard = false;
    this.renderer.removeClass(this.Modal.nativeElement, "active");
  }

  showPopup() {
    this.renderer.addClass(this.Modal.nativeElement, "active");
  }

  async Selfie() {
    let dobd = this.RegistrationForm.controls["DobdaySelect"].value;
    let dobm = this.RegistrationForm.controls["DobMonthSelect"].value;
    let doby = this.RegistrationForm.controls["DobYearSelect"].value;

    let doid = this.RegistrationForm.controls["issuedaySelect"].value;
    let doim = this.RegistrationForm.controls["issueMonthSelect"].value;
    let doiy = this.RegistrationForm.controls["issueYearSelect"].value;

    let doed = this.RegistrationForm.controls["DoedaySelect"].value;
    let doem = this.RegistrationForm.controls["DoeMonthSelect"].value;
    let doey = this.RegistrationForm.controls["DoeYearSelect"].value;

    if (dobd == "0" || dobm == "0" || doby == "0") {
      await this.commonP.showErrorAlert(
        "Sorry",
        "Date of Birth from your ID card scan could not be extracted. Please scan again.",
        ["Ok"],
        this._router
      );

      return;
    }

    if (doid == "0" || doim == "0" || doiy == "0") {
      await this.commonP.showErrorAlert(
        "Sorry",
        "Date of Issuance from your ID card scan could not be extracted. Please scan again.",
        ["Ok"],
        this._router
      );

      return;
    }

    if (!this.IslifeTime) {
      if (doed == "0" || doem == "0" || doey == "0") {
        await this.commonP.showErrorAlert(
          "Sorry",
          "Date of expiry from your ID card scan could not be extracted. Please scan again.",
          ["Ok"],
          this._router
        );

        return;
      }
    }
    if (this.isManual) {
    } else {
      this.DoSelfiePopUp();
    }
  }
  async DoSelfiePopUp() {
    debugger
    await this.setupDevices();
    this.Acceptcondition = false;
    // this.livenessagree = false;
    this.commonP.presentLoading();
    this.renderer.addClass(this.Modal4.nativeElement, "active");
    this.commonP.hideLoading();
  }
  hidePopup4() {
    this.renderer.removeClass(this.Modal4.nativeElement, "active");
  }

  agree = false;
  checkformPermision() {
    if (this.terms) {
      this.agree = true;
    } else {
      this.agree = false;
    }
  }

  async AcuantOperation() {
    let id = Guid.create();
    let uniqueId = id.toString();
    let personFaceImage = this.auth.registrationfblObject.personFaceImage;
    let selfieimg = this.imagebase64;

    let Idnumber = this.auth.registrationfblObject.documentNumber;
    //console.log(selfieimg, personFaceImage, Idnumber, "jfbjbfjdbj")
    this.commonP.presentLoading();

    await this.auth
      .AcuantOperation(personFaceImage, selfieimg, Idnumber, uniqueId)
      .then(async (data: any) => {
        if (data?.response?.code == 1) {
          this.commonP.hideLoading();
          debugger;
          if (this.loginresponse == null) {
            this.auth.registrationfblObject.selfietransactionid =
              data.response.content.selfieTransactionid;
            this.auth.registrationfblObject.facialtransactionid =
              data.response.content.facialTransactionid;
          } else {
            this.auth.IdCardObject.personFaceImage = personFaceImage;
            this.auth.IdCardObject.selfietransactionid =
              data.response.content.selfieTransactionid;
            this.auth.IdCardObject.facialtransactionid =
              data.response.content.facialTransactionid;
          }
          this.UserRegister = true;
          this.Selfiescan = false;
          await this.RegisterUser();
        } else {
          if (data?.error?.response?.code == 102) {
            // this.livenessagree = false;

            this.CampTempimag = [];
            this.selfieimg = null;
            this.commonP.parseError(data).then((mes) => {
              this.translate
                .get(["Sorry", "RetakeSelfie"])
                .subscribe((data) => {
                  this.commonP
                    .showErrorAlert(
                      data["Sorry"],
                      mes,
                      data["RetakeSelfie"],
                      this._router
                    )
                    .then((res) => {
                      if (res == Config.RetakeSelfie) {
                        debugger;
                        this.retake();
                      }
                    });
                });
            });
          } else if (data?.error?.response?.code == 104) {
            this.selfieimg = null;
            this.CampTempimag = [];
            this.count++;
            console.log(this.count);
            //this.livenessagree = false;

            if (this.count >= Number(Config.SelfieCount)) {
              this.commonP.parseError(data).then((mes) => {
                this.translate
                  .get(["Sorry", "RetakeSelfie", "RetryIDCard"])
                  .subscribe((data) => {
                    this.commonP
                      .showTwoButtonAlert(
                        data["Sorry"],
                        mes,
                        [data["RetakeSelfie"], data["RetryIDCard"]],
                        this._router
                      )
                      .then((res) => {
                        if (res == Config.RetakeSelfie) {
                          debugger;
                          this.retake();
                        } else if (res == Config.RetryIDCard) {
                          debugger;
                          this.ScanID = false;
                          // this.renderer.removeChild(
                          //   this.elementRef.nativeElement,
                          //   this.script
                          // );

                          this.IDCard();
                        } else {
                          debugger;
                          this.retake();
                        }
                      });
                  });
              });
            } else {
              this.commonP.parseError(data).then((mes) => {
                this.translate
                  .get(["Sorry", "RetakeSelfie"])
                  .subscribe((data) => {
                    this.commonP
                      .showErrorAlert(
                        data["Sorry"],
                        mes,
                        data["RetakeSelfie"],
                        this._router
                      )
                      .then((res) => {
                        if (res == Config.RetakeSelfie) {
                          debugger;
                          this.retake();
                        }
                      });
                  });
              });
            }

            // this.commonP.parseError(data).then((mes) => {

            //   this.translate.get(['Sorry', 'RetakeSelfie', 'Ok']).subscribe(data => {

            //     if (this.count >= Number(Config.SelfieCount)) {
            //

            //     }
            //     else {
            //       this.commonP.showErrorAlert(data['Sorry'], mes, data['Ok'], this._router).then(res => {
            //         if (res == Config.RetakeSelfie) {
            //           this.retake()
            //         }
            //       });
            //     }

            //   })
            // });
          } else {
            this.clearForm();
            this.commonP.hideLoading();
            this.showNadraRecipte = false;
            this.ValidIdCard = false;
            this.commonP.ParseErrorAlert("", "", this._router, data);
          }
        }
      });
  }

  async clearForm() {
    this.CampTempimag = [];
    this.imagebase64 = null;
    this.front = null;
    this.selfieimg = null;
    this.back = null;

    this.FirstName = "";
    this.MiddleName = "";
    this.LastName = "";
    this.IDNumber = "";
    this.FatherName = "";

    this.RegistrationForm.get("Gender").setValue("");
    this.FirstName = "";
    this.MiddleName = "";
    this.LastName = "";
    this.IDNumber = "";

    this.Gender = "";

    this.DobdaySelect = "";
    this.DobMonthSelect = "";
    this.DobYearSelect = "";

    this.DoedaySelect = "";
    this.DoeMonthSelect = "";
    this.DoeYearSelect = "";

    this.issuedaySelect = "";
    this.issueMonthSelect = "";
    this.issueYearSelect = "";

    this.IslifeTime = false;
    this.IsNotlifeTime = false;
    this.showdoe = false;
    this.cnictype = false;
    this.snictype = false;
    this.nicoptype = false;
    this.commonP.hideLoading();
  }

  labelLink(e) {
    e.preventDefault();
    window.open("~/../assets/IdScan-guidelines.pdf", "_blank");
  }
  labelLink2(e) {
    e.preventDefault();
    window.open("~/../assets/selfi-guidlines.pdf", "_blank");
  }
  changeAgree(event) {
    if (event.srcElement.checked) {
      this.Acceptcondition = true;
    } else {
      this.Acceptcondition = false;
    }
  }

  agreevalid() {
    if (this.Acceptcondition) {
      return false;
    }
    return true;
  }

  // livnessagreevalid() {
  //   if (this.livenessagree) {
  //     return false;
  //   }
  //   return true;
  // }

  // livnessagree(event) {
  //   if (event.srcElement.checked) {
  //     this.livenessagree = true;
  //   } else {
  //     this.livenessagree = false;
  //   }
  // }

  showPopupNadraslip() {
    this.renderer.addClass(this.ModalNadraslip.nativeElement, "active");
  }

  uploadrecipt() {
    this.commonP.presentLoading();
    let defaultPorduct: number = 36;
    if (this.isMinorFlow) {
      defaultPorduct = 60;
    }
    debugger;
    return new Promise((resolve, reject) => {
      this.auth
        .Saveuploadrecipt(this.auth.accessToken, this.Uploaddocmentreceipt, this.isMinorFlow ? "G" : "C")
        .then(async (data: any) => {
          if (data?.response?.code == 1) {
            this.commonP.presentLoading();
            this.kyc
              .GetKycStatus(
                this.auth.accessToken,

                this.auth.data.onBoardingAccount?.applicationId
                  ? this.auth.data.onBoardingAccount.productId
                  : defaultPorduct
              )
              .then(async (data: any) => {
                if (data?.response?.code == 1) {
                  if (this.kyc.totalCount > 0) {
                    let nextscreen = this.kyc.getScreen(this.kyc.count);
                    if (nextscreen == "/PAK-nationality-details") {
                      this.commonP.hideLoading();
                    }
                    this._router.navigateByUrl(nextscreen);
                    this.commonP.hideLoading();
                  }
                }
              });
          } else {
            this.commonP.ParseErrorAlert("", "", this._router, data);
            this.commonP.hideLoading();
          }
        });
    });
  }
  Image;
  enableuploadbtn: boolean = true;
  Uploaddocmentreceipt: string = "";
  PostToTempImage(data) {
    this.Uploaddocmentreceipt = "";
    if (Array.isArray(data)) {
      //data can be array of 4 length OR data can be only bas64
      this.Image = data;
      if (data[3] == "jpeg" || data[3] == "png") {
        this.Image[3] = "JPEG/PNG";
        this.enableuploadbtn = false;
        this.Uploaddocmentreceipt = this.Image[1];
      }
    } else {
      this.Image = data;
      this.Uploaddocmentreceipt = this.Image;
      this.enableuploadbtn = false;
    }
  }
  DocsObject2: DocList[] = [];
  RemoveFunction() {
    this.enableuploadbtn = true;
  }
  scanningopt(e, key) {
    if (key == 0) {
      // this.ValidIdCard = true;
      this.Acceptcondition = false;
      this.showNadraRecipte = false;
      this.ScanID = false;
      this.IDCard();
    } else if (key == 1) {
      this.ValidIdCard = false;
      this.showNadraRecipte = true;
    }
  }

  Scanidcard() {
    this.IDCard();
  }

  async ngAfterViewInit() { }

  async setupDevices() {
    console.log("ddsvdv");
    try {
      const stream1 = await navigator.mediaDevices.getUserMedia({
        audio: false,
        video: true,
      });
      console.log(stream1, "stream");
      if (stream1) {
        // window.stream = stream1; // make stream available to browser console
        this.video.nativeElement.srcObject = stream1;
        this.video.nativeElement.play();
        this.error = null;
      } else {
        this.error = "You have no output video device";
      }
    } catch (e) {
      this.error = e;
    }
  }
  triggerSnapshot(): void {
    this.trigger.next();
  }

  handleImage(webcamImage: WebcamImage): void {
    if (
      this.deviceInfo.device == "iPhone" ||
      this.deviceInfo.deviceType == "desktop"
    ) {
      this.CampTempimag = [];
      this.selfieimg = null;
      this.webcamImage = webcamImage;
      this.imagebase64 = this.webcamImage.imageAsBase64;
      this.CameraViewer = true;

      if (this.imagebase64) {
        this.CampTempimag.push({
          Key: 0,
          value: this.webcamImage.imageAsDataUrl,
        });
      }
      this.hidePopup1();
      this.renderer.setAttribute(
        this.imagetag2.nativeElement,
        "src",
        this.webcamImage.imageAsDataUrl
      );

      // console.log('capture ', this.imagebase64);

      this.renderer.addClass(this.Modal3.nativeElement, "active");
    } else {
      this.drawImageToCanvas(this.video.nativeElement);
      this.CampTempimag = [];
      this.selfieimg = null;
      var destCtx = this.canvas.nativeElement.getContext("2d");
      debugger;
      // this.canvas.nativeElement.height = 500;
      //this.canvas.nativeElement.width = 500;
      destCtx.translate(this.video.nativeElement.videoWidth, 0);
      debugger;
      destCtx.scale(-1, 1);
      debugger;
      destCtx.drawImage(this.canvas.nativeElement, 0, 0);
      debugger;
      this.webcamImage = this.canvas.nativeElement.toDataURL("image/png");
      var base64 = this.canvas.nativeElement.toDataURL("image/png").split(",");
      // console.log(base64)
      this.imagebase64 = base64[1];
      this.CameraViewer = true;

      if (this.imagebase64) {
        this.CampTempimag.push({
          Key: 0,
          value: this.canvas.nativeElement.toDataURL("image/png"),
        });
      }
      this.hidePopup1();

      this.renderer.addClass(this.Modal3.nativeElement, "active");
    }
  }

  drawImageToCanvas(image: any) {
    /*  this.canvas.nativeElement
        .getContext("2d")
        .drawImage(image, 0, 0, this.WIDTH, this.HEIGHT);*/
    // var destCtx = this.canvas.nativeElement.getContext('2d');

    this.canvas.nativeElement
      .getContext("2d")
      .drawImage(image, 0, 0, this.WIDTH, this.HEIGHT);
  }

  showPopupAttachfront() {
    this.renderer.addClass(this.modalAttachfront.nativeElement, "active");
  }

  hidePopupAttachfront() {
    this.renderer.removeClass(this.modalAttachfront.nativeElement, "active");
  }

  removeAttachImagefront() {
    this.renderer.removeClass(this.modalAttachfront.nativeElement, "active");
    this.frontimagebase64 = "";
    this.frontimagebase641 = "";
    this.AttachImage = false;
    this.isImageSaved = false;
    this.showscanid = false;
    this.ScanID = false;
    this.auth.CleanregistrationfblObject();
    this.clearForm();
    this.inputImageFileFrontSide.value = "";
    document.getElementById("screen-start-front")?.classList.remove("hidden");
  }

  showPopupAttachback() {
    this.renderer.addClass(this.modalAttachback.nativeElement, "active");
  }

  hidePopupAttachback() {
    this.renderer.removeClass(this.modalAttachback.nativeElement, "active");
  }

  removeAttachImageback() {
    this.renderer.removeClass(this.modalAttachback.nativeElement, "active");
    this.backimagebase64 = "";
    this.backimagebase641 = "";
    this.AttachImage1 = false;
    this.isImageSaved1 = false;
    this.showscanid = false;
    this.ScanID = false;
    this.auth.CleanregistrationfblObject();
    this.clearForm();
    this.inputImageFileBackSide.value = "";
    document.getElementById("screen-start-back")?.classList.remove("hidden");
  }
  imageError;
  frontcardImageBase64;
  backcardImageBase64;
  frontimage64;
  frontimagebase64;
  backimage64;
  backimagebase64;
  AttachImage: boolean = false;
  isImageSaved: boolean = false;
  AttachImage1: boolean = false;
  isImageSaved1: boolean = false;
  frontimagebase641;
  backimagebase641;
  imageErrorfront;
  imageErrorback;
  async fileChangeEvent(fileInput: any, type) {
    // console.log(fileInput, "fileInput")
    this.commonP.presentLoading();

    this.imageError = null;
    this.imageErrorfront = null;
    this.imageErrorback = null;
    if (fileInput.target.files && fileInput.target.files[0]) {
      // Size Filter Bytes
      const max_size = 5000000;
      const allowed_types = ["image/png", "image/jpeg"];
      const max_height = 2229;
      const max_width = 8386;

      if (fileInput.target.files[0].size > max_size) {
        if (type == "front") {
          this.imageErrorfront =
            "You have exceeded 5 MB. Please upload a valid format page.";
          this.commonP.hideLoading();
          return false;
        } else {
          this.imageErrorback =
            "You have exceeded 5 MB. Please upload a valid format page.";
          this.commonP.hideLoading();
          return false;
        }
      }

      const reader = new FileReader();
      reader.onload = (e: any) => {
        //console.log(e.target.result, "e.target.result")
        const image = new Image();
        image.src = e.target.result;
        image.onload = (rs) => {
          const img_height = rs.currentTarget["height"];
          const img_width = rs.currentTarget["width"];

          if (img_height > max_height && img_width > max_width) {
            if (type == "front") {
              this.imageErrorfront =
                "Maximum dimentions allowed " +
                max_height +
                "*" +
                max_width +
                "px";
              return false;
            } else {
              this.imageErrorback =
                "Maximum dimentions allowed " +
                max_height +
                "*" +
                max_width +
                "px";
              return false;
            }
          } else {
            if (type == "front") {
              const imgBase64Path = e.target.result;
              this.frontcardImageBase64 = imgBase64Path;
              this.frontimage64 = this.frontcardImageBase64.split(",");
              this.frontimagebase64 = this.frontimage64[1];
              this.frontimagebase641 = this.Sanitizer.bypassSecurityTrustUrl(
                "data:image/jpg;base64, " + this.frontimagebase64
              );
              this.AttachImage = true;
              this.isImageSaved = true;
              this.commonP.hideLoading();
              document
                .getElementById("screen-start-front")
                ?.classList.add("hidden");
              document.getElementById("start-front")?.classList.add("hidden");

            } else {
              const imgBase64Path = e.target.result;
              this.backcardImageBase64 = imgBase64Path;
              this.backimage64 = this.backcardImageBase64.split(",");
              this.backimagebase64 = this.backimage64[1];
              this.backimagebase641 = this.Sanitizer.bypassSecurityTrustUrl(
                "data:image/jpg;base64, " + this.backimagebase64
              );
              this.AttachImage1 = true;
              this.isImageSaved1 = true;
              document
                .getElementById("screen-start-back")
                ?.classList.add("hidden");
              document.getElementById("start-back")?.classList.add("hidden");

              this.commonP.hideLoading();
            }

            // this.renderer.setAttribute(this.imagetag.nativeElement, 'src', this.image64[0] + ',' + this.image64[1]);

            //this.callParentFunction.emit(this.imagebase64);
          }
        };
      };
      reader.readAsDataURL(fileInput.target.files[0]);
    }
  }
  ScanViewUpload() {
    if (!this.AttachImage || !this.AttachImage1) {
      return true;
    } else {
      return false;
    }
  }

  ngOnDestroy() {
    //this.renderer.removeChild(this.elementRef.nativeElement, this.script);
    this.commonP.Set("idcardexpire", "");
    this.commonP.Set("minor", "");

    this.hidePopup();
  }

  ////DATECHANGEHANDLING
  doemin;
  doemax;
  dobmax;
  dobdayslistArray: string[] = [];
  doedayslistArray: string[] = [];
  issuedayslistArray: string[] = [];
  dobmonthlistArray = [
    {
      value: "01",
      text: "January",
    },
    {
      value: "02",
      text: "February",
    },
    {
      value: "03",
      text: "March",
    },
    {
      value: "04",
      text: "April",
    },
    {
      value: "05",
      text: "May",
    },
    {
      value: "06",
      text: "June",
    },
    {
      value: "07",
      text: "July",
    },
    {
      value: "08",
      text: "August",
    },
    {
      value: "09",
      text: "September",
    },
    {
      value: "10",
      text: "October",
    },
    {
      value: "11",
      text: "November",
    },
    {
      value: "12",
      text: "December",
    },
  ];

  doemonthlistArray = [
    {
      value: "01",
      text: "January",
    },
    {
      value: "02",
      text: "February",
    },
    {
      value: "03",
      text: "March",
    },
    {
      value: "04",
      text: "April",
    },
    {
      value: "05",
      text: "May",
    },
    {
      value: "06",
      text: "June",
    },
    {
      value: "07",
      text: "July",
    },
    {
      value: "08",
      text: "August",
    },
    {
      value: "09",
      text: "September",
    },
    {
      value: "10",
      text: "October",
    },
    {
      value: "11",
      text: "November",
    },
    {
      value: "12",
      text: "December",
    },
  ];

  issuemonthlistArray = [
    {
      value: "01",
      text: "January",
    },
    {
      value: "02",
      text: "February",
    },
    {
      value: "03",
      text: "March",
    },
    {
      value: "04",
      text: "April",
    },
    {
      value: "05",
      text: "May",
    },
    {
      value: "06",
      text: "June",
    },
    {
      value: "07",
      text: "July",
    },
    {
      value: "08",
      text: "August",
    },
    {
      value: "09",
      text: "September",
    },
    {
      value: "10",
      text: "October",
    },
    {
      value: "11",
      text: "November",
    },
    {
      value: "12",
      text: "December",
    },
  ];

  DobIsFebSelect: boolean = false;
  Dobisyearleap: boolean = false;
  DobdefaultSelect: boolean = true;
  DobthirtySelect;

  DoeIsFebSelect: boolean = false;
  Doeisyearleap: boolean = false;
  DoedefaultSelect: boolean = true;
  DoethirtySelect;

  issueIsFebSelect: boolean = false;
  issueisyearleap: boolean = false;
  issuedefaultSelect: boolean = true;
  issuethirtySelect;

  dobstring;
  doestring;
  issuestring;

  doeyears;
  dobyears;
  issuedateyears;
  dobmaxarray;
  issuemax;

  dobError;
  dobErrorday;
  dobErrormonth;
  dobErroryear;

  DobSelectionchanges() {
    const sb = document.querySelector("#dobdayslist") as HTMLSelectElement;
    const se = document.querySelector("#dobmonthlist") as HTMLSelectElement;

    if (this.DobdaySelect != null) {
      sb.style.color = "#354F52";
    } else if (this.DobdaySelect == null) {
      sb.style.color = "red";
    }
    if (this.DobMonthSelect != null) {
      se.style.color = "#354F52";
    } else if (this.DobMonthSelect == null) {
      se.style.color = "red";
    }

    var array = this.dobmax.split("-");

    var day = Number(array[2]);
    var month = Number(array[1]);
    var year = array[0];

    this.RegistrationForm.patchValue({ DOB: null });

    if (this.DobYearSelect != null) {
      var check = this.leapYear(this.DobYearSelect);
    }

    if (
      this.DobdaySelect != null &&
      this.DobMonthSelect != null &&
      this.DobYearSelect != null
    ) {
      if (this.DobMonthSelect.toString().length == 1) {
        var monthvalue = "0" + this.DobMonthSelect;
      }
      if (this.DobdaySelect.toString().length == 1) {
        var DobdaySelectvalue = "0" + this.DobdaySelect;
      }
      if (monthvalue != null && DobdaySelectvalue != null) {
        this.dobstring =
          this.DobYearSelect + "-" + monthvalue + "-" + DobdaySelectvalue;
      } else if (monthvalue != null && DobdaySelectvalue == null) {
        this.dobstring =
          this.DobYearSelect + "-" + monthvalue + "-" + this.DobdaySelect;
      } else if (monthvalue == null && DobdaySelectvalue != null) {
        this.dobstring =
          this.DobYearSelect +
          "-" +
          this.DobMonthSelect +
          "-" +
          DobdaySelectvalue;
      } else if (monthvalue == null && DobdaySelectvalue == null) {
        this.dobstring =
          this.DobYearSelect +
          "-" +
          this.DobMonthSelect +
          "-" +
          this.DobdaySelect;
      }
      if (this.dobstring > this.dobmax) {
        this.dobError = true;
        this.RegistrationForm.patchValue({ DOB: null });
      } else {
        this.dobError = false;
        this.RegistrationForm.patchValue({ DOB: this.dobstring });
      }
    }

    //logic goes here
    if (
      this.DobMonthSelect == "1" ||
      this.DobMonthSelect == "3" ||
      this.DobMonthSelect == "5" ||
      this.DobMonthSelect == "7" ||
      this.DobMonthSelect == "8" ||
      this.DobMonthSelect == "10" ||
      this.DobMonthSelect == "12"
    ) {
      if (this.DobYearSelect != year) {
        if (!this.dobdayslistArray.includes("28")) {
          this.dobdayslistArray.push("28");
        }
        if (!this.dobdayslistArray.includes("29")) {
          this.dobdayslistArray.push("29");
        }
        if (!this.dobdayslistArray.includes("30")) {
          this.dobdayslistArray.push("30");
        }
        if (!this.dobdayslistArray.includes("31")) {
          this.dobdayslistArray.push("31");
        }
      }
    } else if (
      (this.DobMonthSelect != "2" && this.DobMonthSelect == "4") ||
      this.DobMonthSelect == "6" ||
      this.DobMonthSelect == "9" ||
      this.DobMonthSelect == "11"
    ) {
      if (this.DobYearSelect != year) {
        if (!this.dobdayslistArray.includes("28")) {
          this.dobdayslistArray.push("28");
        }
        if (!this.dobdayslistArray.includes("29")) {
          this.dobdayslistArray.push("29");
        }
        if (!this.dobdayslistArray.includes("30")) {
          this.dobdayslistArray.push("30");
        }

        var lastindex = this.dobdayslistArray.length - 1;
        if (this.dobdayslistArray.includes("31")) {
          this.dobdayslistArray.splice(lastindex, 1);
        }

        if (this.DobdaySelect == "31") {
          this.DobdaySelect = null;
        }
      }
    } else if (this.DobMonthSelect == "2") {
      if (this.DobYearSelect != null) {
        if (check) {
          if (!this.dobdayslistArray.includes("28")) {
            this.dobdayslistArray.push("28");
          }
          if (!this.dobdayslistArray.includes("29")) {
            this.dobdayslistArray.push("29");
          }

          var lastindex = this.dobdayslistArray.length - 1;
          if (this.dobdayslistArray.includes("31")) {
            this.dobdayslistArray.splice(lastindex, 1);
          }

          var lastindex = this.dobdayslistArray.length - 1;
          if (this.dobdayslistArray.includes("30")) {
            this.dobdayslistArray.splice(lastindex, 1);
          }

          if (this.DobdaySelect == "30" || this.DobdaySelect == "31") {
            this.DobdaySelect = null;
          }
        } else {
          if (this.DobYearSelect != year) {
            if (!this.dobdayslistArray.includes("28")) {
              this.dobdayslistArray.push("28");
            }

            var lastindex = this.dobdayslistArray.length - 1;
            if (this.dobdayslistArray.includes("31")) {
              this.dobdayslistArray.splice(lastindex, 1);
            }

            var lastindex = this.dobdayslistArray.length - 1;
            if (this.dobdayslistArray.includes("30")) {
              this.dobdayslistArray.splice(lastindex, 1);
            }

            var lastindex = this.dobdayslistArray.length - 1;
            if (this.dobdayslistArray.includes("29")) {
              this.dobdayslistArray.splice(lastindex, 1);
            }

            if (
              this.DobdaySelect == "29" ||
              this.DobdaySelect == "30" ||
              this.DobdaySelect == "31"
            ) {
              this.DobdaySelect = null;
            }
          }
        }
      } else {
        if (this.DobYearSelect != year) {
          if (!this.dobdayslistArray.includes("28")) {
            this.dobdayslistArray.push("28");
          }
          var lastindex = this.dobdayslistArray.length - 1;
          if (this.dobdayslistArray.includes("31")) {
            this.dobdayslistArray.splice(lastindex, 1);
          }
          var lastindex = this.dobdayslistArray.length - 1;
          if (this.dobdayslistArray.includes("30")) {
            this.dobdayslistArray.splice(lastindex, 1);
          }
          var lastindex = this.dobdayslistArray.length - 1;
          if (this.dobdayslistArray.includes("29")) {
            this.dobdayslistArray.splice(lastindex, 1);
          }

          if (
            this.DobdaySelect == "29" ||
            this.DobdaySelect == "30" ||
            this.DobdaySelect == "31"
          ) {
            this.DobdaySelect = null;
          }
        }
      }
    }

    var anotherdobdayslistArray = [];
    for (var i = 1; i <= 31; i++) {
      anotherdobdayslistArray.push(i);
    }

    if (this.DobYearSelect != null) {
      if (this.DobYearSelect == year) {
        if (this.DobdaySelect == null || Number(this.DobdaySelect) >= day) {
          if (
            this.DobMonthSelect == null ||
            Number(this.DobMonthSelect) >= month
          ) {
            var index = this.dobdayslistArray.indexOf(day.toString());
            for (var i = index + 1; i <= 31; i++) {
              this.dobdayslistArray.splice(index + 1, 1);
            }

            if (
              Number(this.DobdaySelect) != day ||
              Number(this.DobdaySelect)! < day
            ) {
              this.DobdaySelect = null;
            }

            var searchTerm = month;
            var newindex = -1;
            for (var i = 0, len = this.dobmonthlistArray.length; i < len; i++) {
              if (this.dobmonthlistArray[i].value === searchTerm.toString()) {
                newindex = i;
                break;
              }
            }

            for (var i = newindex + 1; i <= 12; i++) {
              this.dobmonthlistArray.splice(newindex + 1, 1);
            }

            if (Number(this.DobMonthSelect) != month) {
              this.DobMonthSelect = null;
            }
          }
        }
      } else if (this.DobYearSelect != year) {
        if (this.DobMonthSelect != null) {
          if (Number(this.DobMonthSelect) <= month) {
            if (this.DobdaySelect) this.DobMonthSelect = null;
            this.DobdaySelect = null;

            this.dobmonthlistArray = [
              {
                value: "1",
                text: "January",
              },
              {
                value: "2",
                text: "February",
              },
              {
                value: "3",
                text: "March",
              },
              {
                value: "4",
                text: "April",
              },
              {
                value: "5",
                text: "May",
              },
              {
                value: "6",
                text: "June",
              },
              {
                value: "7",
                text: "July",
              },
              {
                value: "8",
                text: "August",
              },
              {
                value: "9",
                text: "September",
              },
              {
                value: "10",
                text: "October",
              },
              {
                value: "11",
                text: "November",
              },
              {
                value: "12",
                text: "December",
              },
            ];

            this.dobdayslistArray = null;
            this.dobdayslistArray = anotherdobdayslistArray;

            this.DobdaySelect = null;
            this.DobMonthSelect = null;
          }
        }
      }
    }
  }

  DobSelectionchange() {
    console.log("DOBFIRE");
    const sb = document.querySelector("#dobdayslist") as HTMLSelectElement;

    this.RegistrationForm.patchValue({ DOB: null });

    if (this.DobYearSelect != null) {
      var check = this.leapYear(this.DobYearSelect);
    }

    sb.validity;

    if (
      this.DobdaySelect != null &&
      this.DobMonthSelect != null &&
      this.DobYearSelect != null
    ) {
      if (this.DobMonthSelect.toString().length == 1) {
        var monthvalue = "0" + this.DobMonthSelect;
      }
      if (this.DobdaySelect.toString().length == 1) {
        var DobdaySelectvalue = "0" + this.DobdaySelect;
      }
      if (monthvalue != null && DobdaySelectvalue != null) {
        this.dobstring =
          this.DobYearSelect + "-" + monthvalue + "-" + DobdaySelectvalue;
      } else if (monthvalue != null && DobdaySelectvalue == null) {
        this.dobstring =
          this.DobYearSelect + "-" + monthvalue + "-" + this.DobdaySelect;
      } else if (monthvalue == null && DobdaySelectvalue != null) {
        this.dobstring =
          this.DobYearSelect +
          "-" +
          this.DobMonthSelect +
          "-" +
          DobdaySelectvalue;
      } else if (monthvalue == null && DobdaySelectvalue == null) {
        this.dobstring =
          this.DobYearSelect +
          "-" +
          this.DobMonthSelect +
          "-" +
          this.DobdaySelect;
      }
      if (this.dobstring > this.dobmax) {
        this.dobError = true;
        this.RegistrationForm.patchValue({ DOB: null });
      } else {
        this.dobError = false;
        this.RegistrationForm.patchValue({ DOB: this.dobstring });
      }
    }

    if (
      this.DobMonthSelect == "1" ||
      this.DobMonthSelect == "3" ||
      this.DobMonthSelect == "5" ||
      this.DobMonthSelect == "7" ||
      this.DobMonthSelect == "8" ||
      this.DobMonthSelect == "10" ||
      this.DobMonthSelect == "12"
    ) {
      if (!this.dobdayslistArray.includes("28")) {
        this.dobdayslistArray.push("28");
      }
      if (!this.dobdayslistArray.includes("29")) {
        this.dobdayslistArray.push("29");
      }
      if (!this.dobdayslistArray.includes("30")) {
        this.dobdayslistArray.push("30");
      }
      if (!this.dobdayslistArray.includes("31")) {
        this.dobdayslistArray.push("31");
      }
    } else if (
      (this.DobMonthSelect != "2" && this.DobMonthSelect == "4") ||
      this.DobMonthSelect == "6" ||
      this.DobMonthSelect == "9" ||
      this.DobMonthSelect == "11"
    ) {
      if (!this.dobdayslistArray.includes("28")) {
        this.dobdayslistArray.push("28");
      }
      if (!this.dobdayslistArray.includes("29")) {
        this.dobdayslistArray.push("29");
      }
      if (!this.dobdayslistArray.includes("30")) {
        this.dobdayslistArray.push("30");
      }

      var lastindex = this.dobdayslistArray.length - 1;
      if (this.dobdayslistArray.includes("31")) {
        this.dobdayslistArray.splice(lastindex, 1);
      }

      if (this.DobdaySelect == "31") {
        this.DobdaySelect = null;
      }
    } else if (this.DobMonthSelect == "2") {
      if (this.DobYearSelect != null) {
        if (check) {
          if (!this.dobdayslistArray.includes("28")) {
            this.dobdayslistArray.push("28");
          }
          if (!this.dobdayslistArray.includes("29")) {
            this.dobdayslistArray.push("29");
          }

          var lastindex = this.dobdayslistArray.length - 1;
          if (this.dobdayslistArray.includes("31")) {
            this.dobdayslistArray.splice(lastindex, 1);
          }

          var lastindex = this.dobdayslistArray.length - 1;
          if (this.dobdayslistArray.includes("30")) {
            this.dobdayslistArray.splice(lastindex, 1);
          }

          if (this.DobdaySelect == "30" || this.DobdaySelect == "31") {
            this.DobdaySelect = null;
          }
        } else {
          if (!this.dobdayslistArray.includes("28")) {
            this.dobdayslistArray.push("28");
          }

          var lastindex = this.dobdayslistArray.length - 1;
          if (this.dobdayslistArray.includes("31")) {
            this.dobdayslistArray.splice(lastindex, 1);
          }

          var lastindex = this.dobdayslistArray.length - 1;
          if (this.dobdayslistArray.includes("30")) {
            this.dobdayslistArray.splice(lastindex, 1);
          }

          var lastindex = this.dobdayslistArray.length - 1;
          if (this.dobdayslistArray.includes("29")) {
            this.dobdayslistArray.splice(lastindex, 1);
          }

          if (
            this.DobdaySelect == "29" ||
            this.DobdaySelect == "30" ||
            this.DobdaySelect == "31"
          ) {
            this.DobdaySelect = null;
          }
        }
      } else {
        if (!this.dobdayslistArray.includes("28")) {
          this.dobdayslistArray.push("28");
        }
        var lastindex = this.dobdayslistArray.length - 1;
        if (this.dobdayslistArray.includes("31")) {
          this.dobdayslistArray.splice(lastindex, 1);
        }
        var lastindex = this.dobdayslistArray.length - 1;
        if (this.dobdayslistArray.includes("30")) {
          this.dobdayslistArray.splice(lastindex, 1);
        }
        var lastindex = this.dobdayslistArray.length - 1;
        if (this.dobdayslistArray.includes("29")) {
          this.dobdayslistArray.splice(lastindex, 1);
        }

        if (
          this.DobdaySelect == "29" ||
          this.DobdaySelect == "30" ||
          this.DobdaySelect == "31"
        ) {
          this.DobdaySelect = null;
        }
      }
    }
  }
  doeError;

  DoeSelectionchange() {
    const sb = document.querySelector("#doedayslist") as HTMLSelectElement;

    this.RegistrationForm.patchValue({ DOE: null });

    if (this.DoeYearSelect != null) {
      var check = this.leapYear(this.DoeYearSelect);
    }

    if (
      this.DoedaySelect != null &&
      this.DoeMonthSelect != null &&
      this.DoeYearSelect != null
    ) {
      if (this.DoeMonthSelect.toString().length == 1) {
        var monthvalue = "0" + this.DoeMonthSelect;
      }
      if (this.DoedaySelect.toString().length == 1) {
        var DoedaySelectvalue = "0" + this.DoedaySelect;
      }
      if (monthvalue != null && DoedaySelectvalue != null) {
        this.doestring =
          this.DoeYearSelect + "-" + monthvalue + "-" + DoedaySelectvalue;
      } else if (monthvalue != null && DoedaySelectvalue == null) {
        this.doestring =
          this.DoeYearSelect + "-" + monthvalue + "-" + this.DoedaySelect;
      } else if (monthvalue == null && DoedaySelectvalue != null) {
        this.doestring =
          this.DoeYearSelect +
          "-" +
          this.DoeMonthSelect +
          "-" +
          DoedaySelectvalue;
      } else if (monthvalue == null && DoedaySelectvalue == null) {
        this.doestring =
          this.DoeYearSelect +
          "-" +
          this.DoeMonthSelect +
          "-" +
          this.DoedaySelect;
      }
      if (this.doestring! < this.doemin) {
        this.doeError = true;
        this.RegistrationForm.patchValue({ DOE: null });
      } else {
        this.doeError = false;
        this.RegistrationForm.patchValue({ DOE: this.doestring });
      }
    }

    if (
      this.DoeMonthSelect == "1" ||
      this.DoeMonthSelect == "3" ||
      this.DoeMonthSelect == "5" ||
      this.DoeMonthSelect == "7" ||
      this.DoeMonthSelect == "8" ||
      this.DoeMonthSelect == "10" ||
      this.DoeMonthSelect == "12"
    ) {
      if (!this.doedayslistArray.includes("28")) {
        this.doedayslistArray.push("28");
      }
      if (!this.doedayslistArray.includes("29")) {
        this.doedayslistArray.push("29");
      }
      if (!this.doedayslistArray.includes("30")) {
        this.doedayslistArray.push("30");
      }
      if (!this.doedayslistArray.includes("31")) {
        this.doedayslistArray.push("31");
      }
    } else if (
      (this.DoeMonthSelect != "2" && this.DoeMonthSelect == "4") ||
      this.DoeMonthSelect == "6" ||
      this.DoeMonthSelect == "9" ||
      this.DoeMonthSelect == "11"
    ) {
      if (!this.doedayslistArray.includes("28")) {
        this.doedayslistArray.push("28");
      }
      if (!this.doedayslistArray.includes("29")) {
        this.doedayslistArray.push("29");
      }
      if (!this.doedayslistArray.includes("30")) {
        this.doedayslistArray.push("30");
      }

      var lastindex = this.doedayslistArray.length - 1;
      if (this.doedayslistArray.includes("31")) {
        this.doedayslistArray.splice(lastindex, 1);
      }

      if (this.DoedaySelect == "31") {
        this.DoedaySelect = null;
      }
    } else if (this.DoeMonthSelect == "2") {
      if (this.DoeYearSelect != null) {
        if (check) {
          if (!this.doedayslistArray.includes("28")) {
            this.doedayslistArray.push("28");
          }
          if (!this.doedayslistArray.includes("29")) {
            this.doedayslistArray.push("29");
          }

          var lastindex = this.doedayslistArray.length - 1;
          if (this.doedayslistArray.includes("31")) {
            this.doedayslistArray.splice(lastindex, 1);
          }

          var lastindex = this.doedayslistArray.length - 1;
          if (this.doedayslistArray.includes("30")) {
            this.doedayslistArray.splice(lastindex, 1);
          }

          if (this.DoedaySelect == "30" || this.DoedaySelect == "31") {
            this.DoedaySelect = null;
          }
        } else {
          if (!this.doedayslistArray.includes("28")) {
            this.doedayslistArray.push("28");
          }

          var lastindex = this.doedayslistArray.length - 1;
          if (this.doedayslistArray.includes("31")) {
            this.doedayslistArray.splice(lastindex, 1);
          }

          var lastindex = this.doedayslistArray.length - 1;
          if (this.doedayslistArray.includes("30")) {
            this.doedayslistArray.splice(lastindex, 1);
          }

          var lastindex = this.doedayslistArray.length - 1;
          if (this.doedayslistArray.includes("29")) {
            this.doedayslistArray.splice(lastindex, 1);
          }

          if (
            this.DoedaySelect == "29" ||
            this.DoedaySelect == "30" ||
            this.DoedaySelect == "31"
          ) {
            this.DoedaySelect = null;
          }
        }
      } else {
        if (!this.doedayslistArray.includes("28")) {
          this.doedayslistArray.push("28");
        }
        var lastindex = this.doedayslistArray.length - 1;
        if (this.doedayslistArray.includes("31")) {
          this.doedayslistArray.splice(lastindex, 1);
        }
        var lastindex = this.doedayslistArray.length - 1;
        if (this.doedayslistArray.includes("30")) {
          this.doedayslistArray.splice(lastindex, 1);
        }
        var lastindex = this.doedayslistArray.length - 1;
        if (this.doedayslistArray.includes("29")) {
          this.doedayslistArray.splice(lastindex, 1);
        }

        if (
          this.DoedaySelect == "29" ||
          this.DoedaySelect == "30" ||
          this.DoedaySelect == "31"
        ) {
          this.DoedaySelect = null;
        }
      }
    }
  }
  leapYear(year) {
    return (year % 4 == 0 && year % 100 != 0) || year % 400 == 0;
  }

  IssueError;
  issueSelectionchange() {
    const sb = document.querySelector("#issuedayslist") as HTMLSelectElement;
    this.RegistrationForm.patchValue({ Issuedate: null });

    if (this.issueYearSelect != null) {
      var check = this.leapYear(this.issueYearSelect);
    }

    if (
      this.issuedaySelect != null &&
      this.issueMonthSelect != null &&
      this.issueYearSelect != null
    ) {
      if (this.issueMonthSelect.toString().length == 1) {
        var monthvalue = "0" + this.issueMonthSelect;
      }
      if (this.issuedaySelect.toString().length == 1) {
        var issuedaySelectvalue = "0" + this.issuedaySelect;
      }
      if (monthvalue != null && issuedaySelectvalue != null) {
        this.issuestring =
          this.issueYearSelect + "-" + monthvalue + "-" + issuedaySelectvalue;
      } else if (monthvalue != null && issuedaySelectvalue == null) {
        this.issuestring =
          this.issueYearSelect + "-" + monthvalue + "-" + this.issuedaySelect;
      } else if (monthvalue == null && issuedaySelectvalue != null) {
        this.issuestring =
          this.issueYearSelect +
          "-" +
          this.issueMonthSelect +
          "-" +
          issuedaySelectvalue;
      } else if (monthvalue == null && issuedaySelectvalue == null) {
        this.issuestring =
          this.issueYearSelect +
          "-" +
          this.issueMonthSelect +
          "-" +
          this.issuedaySelect;
      }
      if (this.issuestring! > this.issuemax) {
        this.IssueError = true;
        this.RegistrationForm.patchValue({ Issuedate: null });
      } else {
        this.IssueError = false;
        this.RegistrationForm.patchValue({ Issuedate: this.issuestring });
      }
    }

    if (
      this.issueMonthSelect == "1" ||
      this.issueMonthSelect == "3" ||
      this.issueMonthSelect == "5" ||
      this.issueMonthSelect == "7" ||
      this.issueMonthSelect == "8" ||
      this.issueMonthSelect == "10" ||
      this.issueMonthSelect == "12"
    ) {
      if (!this.issuedayslistArray.includes("28")) {
        this.issuedayslistArray.push("28");
      }
      if (!this.issuedayslistArray.includes("29")) {
        this.issuedayslistArray.push("29");
      }
      if (!this.issuedayslistArray.includes("30")) {
        this.issuedayslistArray.push("30");
      }
      if (!this.issuedayslistArray.includes("31")) {
        this.issuedayslistArray.push("31");
      }
    } else if (
      (this.issueMonthSelect != "2" && this.issueMonthSelect == "4") ||
      this.issueMonthSelect == "6" ||
      this.issueMonthSelect == "9" ||
      this.issueMonthSelect == "11"
    ) {
      if (!this.issuedayslistArray.includes("28")) {
        this.issuedayslistArray.push("28");
      }
      if (!this.issuedayslistArray.includes("29")) {
        this.issuedayslistArray.push("29");
      }
      if (!this.issuedayslistArray.includes("30")) {
        this.issuedayslistArray.push("30");
      }

      var lastindex = this.issuedayslistArray.length - 1;
      if (this.issuedayslistArray.includes("31")) {
        this.issuedayslistArray.splice(lastindex, 1);
      }

      if (this.issuedaySelect == "31") {
        this.issuedaySelect = null;
      }
    } else if (this.issueMonthSelect == "2") {
      if (this.issueYearSelect != null) {
        if (check) {
          if (!this.issuedayslistArray.includes("28")) {
            this.issuedayslistArray.push("28");
          }
          if (!this.issuedayslistArray.includes("29")) {
            this.issuedayslistArray.push("29");
          }

          var lastindex = this.issuedayslistArray.length - 1;
          if (this.issuedayslistArray.includes("31")) {
            this.issuedayslistArray.splice(lastindex, 1);
          }

          var lastindex = this.issuedayslistArray.length - 1;
          if (this.issuedayslistArray.includes("30")) {
            this.issuedayslistArray.splice(lastindex, 1);
          }

          if (this.issuedaySelect == "30" || this.issuedaySelect == "31") {
            this.issuedaySelect = null;
          }
        } else {
          if (!this.issuedayslistArray.includes("28")) {
            this.issuedayslistArray.push("28");
          }

          var lastindex = this.issuedayslistArray.length - 1;
          if (this.issuedayslistArray.includes("31")) {
            this.issuedayslistArray.splice(lastindex, 1);
          }

          var lastindex = this.issuedayslistArray.length - 1;
          if (this.issuedayslistArray.includes("30")) {
            this.issuedayslistArray.splice(lastindex, 1);
          }

          var lastindex = this.issuedayslistArray.length - 1;
          if (this.issuedayslistArray.includes("29")) {
            this.issuedayslistArray.splice(lastindex, 1);
          }

          if (
            this.issuedaySelect == "29" ||
            this.issuedaySelect == "30" ||
            this.issuedaySelect == "31"
          ) {
            this.issuedaySelect = null;
          }
        }
      } else {
        if (!this.issuedayslistArray.includes("28")) {
          this.issuedayslistArray.push("28");
        }
        var lastindex = this.issuedayslistArray.length - 1;
        if (this.issuedayslistArray.includes("31")) {
          this.issuedayslistArray.splice(lastindex, 1);
        }
        var lastindex = this.issuedayslistArray.length - 1;
        if (this.issuedayslistArray.includes("30")) {
          this.issuedayslistArray.splice(lastindex, 1);
        }
        var lastindex = this.issuedayslistArray.length - 1;
        if (this.issuedayslistArray.includes("29")) {
          this.issuedayslistArray.splice(lastindex, 1);
        }

        if (
          this.issuedaySelect == "29" ||
          this.issuedaySelect == "30" ||
          this.issuedaySelect == "31"
        ) {
          this.issuedaySelect = null;
        }
      }
    }
  }

  async ProcessResult(
    data,
    _self: this,
    videoRecognizer,
    recognizerRunner,
    combinedGenericIDRecognizer
  ) {
    this.ValidIdCard = true;
    //console.log(JSON.stringify(data), "IDCard Data");
    var result = data;
    //alert("Inside Process Result");

    _self.commonP.hideLoading();
    //alert("After loader dismiss");

    if (result) {
      clearInterval(this.showHandle);
      //  alert(JSON.stringify(result));
      _self.nicoptype = false;
      _self.cnictype = false;
      var frontSuccessfulImage;
      var faceSuccessfulImage;
      if (result.faceImage) {
        //   alert("Object has face image object");
      }
      if (result?.faceImage?.encodedImage) {
        // alert("face image object has encoded image array");
      }
      var encodedfaceImage = result?.faceImage?.encodedImage;

      faceSuccessfulImage = _self.Uint8ToBase64(encodedfaceImage);
      setTimeout(async () => {
        //  alert(faceSuccessfulImage);
        if (faceSuccessfulImage) {
          //  alert("Face Image Found");
        } else {
          //  alert("Face Image Not Found");
        }
        var encodedFrontImage = result?.fullDocumentFrontImage?.encodedImage;
        if (result?.fullDocumentFrontImage?.encodedImage)
          frontSuccessfulImage = _self.Uint8ToBase64(encodedFrontImage);
        if (frontSuccessfulImage) {
          // alert("Front Image");
        } else {
          //  alert("Front Image not found");
        }
        var encodedBackImage = result.fullDocumentBackImage.encodedImage;
        var backSuccessfulImage = _self.Uint8ToBase64(encodedBackImage);
        if (backSuccessfulImage) {
          //  alert("backSuccessfulImage");
        } else {
          //  alert("Back Image not found");
        }

        // if (!frontSuccessfulImage) {
        _self.dataCaptured = true;
        // Front image
        var docImage = frontSuccessfulImage;
        if (docImage) {
          _self.front = _self.Sanitizer.bypassSecurityTrustUrl(
            "data:image/jpg;base64, " + docImage
          );
          _self.frontBlob = _self.dataURLtoBlob(
            "data:image/jpg;base64, " + docImage
          );
          _self.auth.registrationfblObject.frontCardImage = docImage;
          _self.frontHide = "1";
          _self.frontsuccess = true;
          console.log("dcdscd");
        }
        // back image
        var backImage = backSuccessfulImage;
        if (backImage) {
          clearTimeout(this.showHandle);
          _self.back = _self.Sanitizer.bypassSecurityTrustUrl(
            "data:image/jpg;base64, " + backImage
          );
          _self.backBlob = _self.dataURLtoBlob(
            "data:image/jpg;base64, " + backImage
          );
          _self.auth.registrationfblObject.backCardImage = backImage;
          _self.frontHide = "1";
          _self.frontsuccess = true;
        }
        // Face image
        var faceimage = faceSuccessfulImage;
        if (faceimage) {
          _self.face = _self.Sanitizer.bypassSecurityTrustUrl(
            "data:image/jpg;base64, " + faceimage
          );
          _self.faceBlob = _self.dataURLtoBlob(
            "data:image/jpg;base64, " + faceimage
          );
          _self.auth.registrationfblObject.personFaceImage = faceimage;
          _self.frontHide = "1";
          _self.faceimage = true;
        }

        var fields = result.mrz;
        //  alert("FieldParsed" + fields.parsed);
        if (fields.parsed == false) {
          var visualData = result.frontViz;
          var countryClass = result.classInfo.country;
          //   alert(countryClass);
          let issuer = _self.country.countries.find(
            (x) => x.blinkCode == countryClass
          );
          if (issuer) {
            var name: string[] = [];

            var middleName = "";
            var familyName = "";
            var fullName = "";

            name = visualData.fullName.split(" ");

            for (var i = 1; i < name.length - 1; i++) {
              middleName = middleName + " " + name[i];
            }
            debugger;
            familyName = name[name.length - 1];
            fullName = visualData.fullName;

            _self.auth.registrationfblObject.issuer = issuer.isoCode3;
            _self.auth.registrationfblObject.nationality = issuer.isoCode3;
            _self.auth.registrationfblObject.familyName = familyName.trim();
            _self.auth.registrationfblObject.middleName = middleName
              ? middleName.trim()
              : "";

            _self.auth.registrationfblObject.firstName = name[0].trim();

            _self.auth.registrationfblObject.documentNumber =
              visualData.personalIdNumber
                ? visualData.personalIdNumber
                  .replace(/-/g, "")
                  .replace(/</g, "")
                  .replace(/O/g, "0")
                  .replace(/o/g, "0")
                  .replace(/l/g, "1")
                : visualData.documentNumber
                  .replace(/-/g, "")
                  .replace(/</g, "")
                  .replace(/O/g, "0")
                  .replace(/o/g, "0")
                  .replace(/l/g, "1");

            _self.auth.registrationfblObject.documentCode = "I";
            _self.auth.registrationfblObject.countryID = issuer.isoCode3;

            _self.auth.registrationfblObject.dOB =
              result.dateOfBirth.month +
              "/" +
              result.dateOfBirth.day +
              "/" +
              result.dateOfBirth.year;
            _self.auth.registrationfblObject.issuedate =
              result.dateOfIssue.month +
              "/" +
              result.dateOfIssue.day +
              "/" +
              result.dateOfIssue.year;
            _self.auth.registrationfblObject.IsLifeTimeCnic =
              result.dateOfExpiryPermanent
                ? result.dateOfExpiryPermanent
                : false;
            debugger;
            if (result.dateOfExpiry) {
              _self.auth.registrationfblObject.dOE =
                result.dateOfExpiry.month +
                "/" +
                result.dateOfExpiry.day +
                "/" +
                result.dateOfExpiry.year;
              _self.auth.registrationfblObject.dOI =
                result.dateOfIssue.month +
                "/" +
                result.dateOfIssue.day +
                "/" +
                result.dateOfIssue.year;

              if (!_self.auth.registrationfblObject.IsLifeTimeCnic) {
                if (_self.auth.registrationfblObject.dOE == "0/0/0") {
                  _self.auth.registrationfblObject.dOE =
                    result.dateOfExpiry.month +
                    "/" +
                    result.dateOfExpiry.day +
                    "/" +
                    result.dateOfExpiry.year;
                }
              }

              if (_self.auth.registrationfblObject.dOI == "0/0/0") {
                _self.auth.registrationfblObject.dOI =
                  result.dateOfIssue.month +
                  "/" +
                  result.dateOfIssue.day +
                  "/" +
                  result.dateOfIssue.year;
              }
            } else {
            }
            _self.IslifeTime = _self.auth.registrationfblObject.IsLifeTimeCnic;

            if (_self.IslifeTime) {
              _self.showdoe = false;
            } else {
              _self.IsNotlifeTime = true;
              _self.showdoe = true;
              _self.DoedaySelect = result.dateOfExpiry.day.toString();
              _self.DoeMonthSelect = result.dateOfExpiry.month.toString();
              _self.DoeYearSelect = result.dateOfExpiry.year.toString();
            }
            _self.ScanType = "I";
            console.log(_self.auth.registrationfblObject);
          } else {
          }
          debugger;
          _self.FirstName = _self.auth.registrationfblObject?.firstName;
          _self.MiddleName = _self.auth.registrationfblObject?.middleName;
          _self.LastName = _self.auth.registrationfblObject?.familyName;
          _self.FatherName = _self.auth.registrationObject?.FatherName;
          _self.IDNumber = _self.auth.registrationfblObject?.documentNumber;

          if (visualData.sex) {
            if (visualData.sex == "M") {
              debugger;
              let accountType = await this.commonP.Get("accountType");

              if (accountType == 'A') {
                this.translate
                  .get(["Sorry", "err-amalRestriction", "OK"])
                  .subscribe((data) => {
                    this.commonP
                      .showErrorAlert(
                        data["Sorry"],
                        data["err-amalRestriction"],
                        data["OK"],
                        this._router
                      )
                      .then((data: any) => { });
                  });

                this._router.navigateByUrl("/MobileVerification");

              }
              else {
                _self.auth.registrationfblObject.gender = visualData.sex;
                _self.Gender = "Male";

                _self.ValidGender = true;
              }

            } else if (visualData.sex == "F") {
              _self.auth.registrationfblObject.gender = visualData.sex;
              _self.Gender = "Female";

              _self.ValidGender = true;
            }
          } else {
            if (_self.IDNumber) {
              let lastdigit = Number(_self.IDNumber) % 10;
              if (lastdigit % 2 == 0) {
                _self.auth.registrationfblObject.gender = visualData.sex;
                _self.Gender = "Female";
                _self.ValidGender = true;
                this.commonP.Set("IDGendertype", _self.Gender);
              } else {
                _self.auth.registrationfblObject.gender = visualData.sex;
                _self.Gender = "Male";
                this.commonP.Set("IDGendertype", _self.Gender);
                _self.ValidGender = true;
              }
            }
          }

          _self.DobdaySelect = result.dateOfBirth.day.toString();
          console.log(_self.DobdaySelect, "Value");
          console.log("ARRAY", this.dobdayslistArray);

          _self.DobMonthSelect = result.dateOfBirth.month.toString();
          _self.DobYearSelect = result.dateOfBirth.year.toString();

          _self.issuedaySelect = result.dateOfIssue.day.toString();
          _self.issueMonthSelect = result.dateOfIssue.month.toString();
          _self.issueYearSelect = result.dateOfIssue.year.toString();

          // _self.cnictype = true;
          // _self.IDtype = "CNIC";

          if (_self.FirstName && _self.LastName) {
            _self.snictype = true;
            _self.cnictype = false;
            _self.IDtype = "SNIC";
          } else {
            _self.cnictype = true;
            _self.snictype = false;
            _self.IDtype = "CNIC";
          }

          _self.ValidIdCard = true;
          _self.ScanID = true;
          _self.showscanid = true;
          _self.Selfiescan = true;
          await _self.commonP.hideLoading();
          // _self.Selfie()
        } else {
          await _self.commonP.hideLoading();
          _self.translate
            .get(["Sorry", "MRZcardnotallowed", "OK"])
            .subscribe((data) => {
              _self.commonP
                .showErrorAlert(
                  data.Sorry,
                  data.MRZcardnotallowed,
                  data.OK,
                  _self._router
                )
                .then(async (res) => {
                  if (res == "Ok") {
                    await _self.startScan();
                  }
                });
            });
        }
        // }
      }, 5000);
      await _self.commonP.hideLoading();
      videoRecognizer?.releaseVideoFeed();
      recognizerRunner?.delete();
      combinedGenericIDRecognizer?.delete();
      document.getElementById("screen-start")?.classList.remove("hidden");
      document.getElementById("screen-scanning")?.classList.add("hidden");
      document.getElementById("show-upload-card")?.classList.add("hidden");
    } else {
      //  alert("Inside Else");
      await _self.commonP.hideLoading();
      _self.front = "./assets/images/TapFront.gif";
      _self.frontHide = "1";
      _self.backHide = "";
      _self.back = "";
    }
  }
  /////////


  async IDCard() {
    let aaaaa: any = await this.auth.GetFromJson();
    console.log("Resposne from FIle", aaaaa.Blink);
    this.JourneyId = aaaaa.IdWisejourneyID;
    this.ClientKey = aaaaa.IdWise;


    if (FBLDevice.Environment.IsNative) {
      //   await this.commonP.presentLoading();
      await this.getcountry();
      // await this.showPopup();
      debugger
      this.StartManualID();
    } else {


      var that = this;
      await that.commonP.presentLoading();
      let idwise;
      var idwisekey = this.ClientKey
      var journeyId = this.JourneyId
      //kashif

      IDWise.initialize({
        //replace xxxx with client key that you have generated from API Keys section in admin panel 

        clientKey: idwisekey,
        locale: "en",
      })
        .then(async result => {
          console.log(result, "result")
          await that.commonP.hideLoading();
          this.hidePopup()
          idwise = result
          idwise.startJourney({
            journeyDefinitionId: journeyId,
            mount: '#idwise-mount',
            eventHandlers: {
              onJourneyStarted: function (details) {

                console.log(details, "onJourneyStarted")

                //alert('Journey started, journey id =' + details.journeyId);
              },
              onJourneyFinished: function (details) {
                console.log(details, "onJourneyFinished")
                // alert('Journey finished, journey id =' + details.journeyId);

                that.getDataidWise(details.journeyId, that)

                debugger
                idwise.cleanup();

              },
              onJourneyCancelled: function (details) {
                alert('Journey cancelled, journey id =' + details.journeyId);
              },
            }
          }).then(async data => {

            console.log(data, "data 2133")
            // this.commonP.presentLoading();

            // this.getDataidWise(details.journeyId)
          });
        })
        .catch(error => {
          alert(error);
        });



    }
  }


  async getDataidWise(journeyId, that) {
    debugger

    this.ngZone.run(async () => {


      await that.commonP.presentLoading();
      let accountType = await that.commonP.Get("accountType");

      if (that.CardDocumentoption == true || accountType == 'M') {

        await that.auth.getIdWiseAuth(journeyId, that.auth.accessToken)
          .then(async (data: any) => {
            console.log(data, "getIdWise")
            await that.commonP.hideLoading();
            if (data?.response?.code == 1) {

              if (accountType == 'A') {

                if (data?.response?.content?.gender == "Male") {

                  that.translate
                    .get(["Sorry", "err-amalRestriction", "OK"])
                    .subscribe((data) => {
                      that.commonP
                        .showErrorAlert(
                          data["Sorry"],
                          data["err-amalRestriction"],
                          data["OK"],
                          that._router
                        )
                        .then((data: any) => { });
                    });



                  that._router.navigateByUrl("/MobileVerification");

                }

              }

              var _self = that;
              _self.ValidIdCard = true;

              _self.auth.registrationfblObject.journeyId = journeyId
              _self.auth.IdCardObject.journeyId = journeyId
              debugger
              _self.auth.registrationfblObject.accountType = accountType ?? "I";

              _self.dataCaptured = true;

              // Front image
              var docImage = data.response.content.frontImage;
              if (docImage) {
                _self.front = _self.Sanitizer.bypassSecurityTrustUrl(
                  "data:image/jpg;base64, " + docImage
                );
                _self.frontBlob = _self.dataURLtoBlob(
                  "data:image/jpg;base64, " + docImage
                );
                _self.auth.registrationfblObject.frontCardImage = docImage;
                _self.frontHide = "1";
                _self.frontsuccess = true;
              }
              // back image
              var backImage = data.response.content.backImage;
              if (backImage) {
                _self.back = _self.Sanitizer.bypassSecurityTrustUrl(
                  "data:image/jpg;base64, " + backImage
                );
                _self.backBlob = _self.dataURLtoBlob(
                  "data:image/jpg;base64, " + backImage
                );
                _self.auth.registrationfblObject.backCardImage = backImage;

                _self.frontHide = "1";
                _self.frontsuccess = true;
              }
              // Face image
              var faceimage = data.response.content.selfie;
              if (faceimage) {
                _self.face = _self.Sanitizer.bypassSecurityTrustUrl(
                  "data:image/jpg;base64, " + faceimage
                );
                _self.faceBlob = _self.dataURLtoBlob(
                  "data:image/jpg;base64, " + faceimage
                );
                _self.auth.registrationfblObject.personFaceImage =
                  faceimage;
                _self.auth.registrationfblObject.selfieimage = faceimage;
                _self.auth.IdCardObject.selfieimage = faceimage;
                _self.auth.IdCardObject.personFaceImage =
                  faceimage;
                _self.frontHide = "1";
                _self.faceimage = true;
              }


              if (data.response.content.nationalitycode) {





                _self.auth.registrationfblObject.issuer = data.response.content.nationalitycode;
                _self.auth.registrationfblObject.nationality =
                  data.response.content.nationalitycode;
                _self.auth.registrationfblObject.familyName = data.response.content.lastName
                _self.auth.registrationObject.FatherName = data.response.content.fatherName
                _self.auth.registrationfblObject.middleName = data.response.content.middleName
                  ? data.response.content.middleName.trim()
                  : "";

                _self.auth.registrationfblObject.firstName = data.response.content.firstName

                _self.auth.registrationfblObject.documentNumber = data.response.content.cnic

                _self.auth.registrationfblObject.documentCode = "I";
                _self.auth.registrationfblObject.countryID =
                  data.response.content.nationalitycode;
                var dateOfBirth = moment(data.response.content.dob).format('MM/D/YYYY');
                _self.auth.registrationfblObject.dOB = dateOfBirth

                var dateOfIssue = moment(data.response.content.issueDate).format('MM/D/YYYY');
                _self.auth.registrationfblObject.issuedate = dateOfIssue
                _self.auth.registrationfblObject.IsLifeTimeCnic =
                  data.response.content.islifeTimeCnic
                    ? data.response.content.islifeTimeCnic
                    : false;
                debugger;

                var dateOfExpiry = moment(data.response.content.idExpiry).format('MM/D/YYYY');
                if (dateOfExpiry) {
                  _self.auth.registrationfblObject.dOE = dateOfExpiry
                  var dateOfIssue = moment(data.response.content.issueDate).format('MM/D/YYYY');
                  _self.auth.registrationfblObject.dOI = dateOfIssue

                  if (!_self.auth.registrationfblObject.IsLifeTimeCnic) {
                    if (_self.auth.registrationfblObject.dOE == "0/0/0") {
                      _self.auth.registrationfblObject.dOE = dateOfExpiry
                    }
                  }

                  if (_self.auth.registrationfblObject.dOI == "0/0/0") {
                    _self.auth.registrationfblObject.dOI = dateOfIssue
                  }
                } else {
                }
                _self.IslifeTime =
                  _self.auth.registrationfblObject.IsLifeTimeCnic;

                if (_self.IslifeTime) {
                  _self.showdoe = false;
                } else {
                  _self.IsNotlifeTime = true;
                  _self.showdoe = true;
                  var expiry = dateOfExpiry.split("/")
                  console.log(expiry, "expiry")
                  _self.DoedaySelect = expiry[1].toString();
                  _self.DoeMonthSelect = expiry[0].toString();
                  _self.DoeYearSelect = expiry[2].toString();
                }
                _self.ScanType = "I";
                console.log(_self.auth.registrationfblObject);
              } else {
              }
              debugger;
              _self.FirstName =
                _self.auth.registrationfblObject?.firstName;
              _self.MiddleName =
                _self.auth.registrationfblObject?.middleName;
              _self.LastName =
                _self.auth.registrationfblObject?.familyName;
              _self.FatherName =
                _self.auth.registrationObject?.FatherName;
              _self.IDNumber =
                _self.auth.registrationfblObject?.documentNumber;
              console.log(_self.auth.registrationfblObject, "_self.auth.registrationfblObject")
              if (data.response.content.gender) {
                if (data.response.content.gender == "Male") {
                  _self.auth.registrationfblObject.gender = data.response.content.gender;
                  _self.Gender = data.response.content.gender;

                  _self.ValidGender = true;
                } else if (data.response.content.gender == "Female") {
                  _self.auth.registrationfblObject.gender = data.response.content.gender;
                  _self.Gender = data.response.content.gender;

                  _self.ValidGender = true;
                }
              } else {
                if (_self.IDNumber) {
                  let lastdigit = Number(_self.IDNumber) % 10;
                  if (lastdigit % 2 == 0) {
                    _self.auth.registrationfblObject.gender = data.response.content.gender;
                    _self.Gender = data.response.content.gender;
                    _self.ValidGender = false;
                    _self.commonP.Set("IDGendertype", _self.Gender);
                  } else {
                    _self.auth.registrationfblObject.gender = data.response.content.gender;
                    _self.Gender = data.response.content.gender;
                    _self.commonP.Set("IDGendertype", _self.Gender);
                    _self.ValidGender = false;
                  }
                }
              }
              var Birth = dateOfBirth.split("/")
              console.log(Birth, "Birth")
              _self.DobdaySelect = Birth[1].toString();
              console.log(_self.DobdaySelect, "Value");
              console.log("ARRAY", this.dobdayslistArray);

              _self.DobMonthSelect = Birth[0].toString();
              _self.DobYearSelect = Birth[2].toString();
              var Issue = dateOfIssue.split("/")
              console.log(Issue, "Issue")
              _self.issuedaySelect = Issue[1].toString();
              _self.issueMonthSelect = Issue[0].toString();
              _self.issueYearSelect = Issue[2].toString();

              // _self.cnictype = true;
              // _self.IDtype = "CNIC";

              if (data.response.content.documentType == "Smart National Identity Card") {
                _self.snictype = true;
                _self.cnictype = false;
                _self.IDtype = "SNIC";
              } else {
                _self.cnictype = true;
                _self.snictype = false;
                _self.IDtype = "CNIC";
              }

              _self.ScanID = true;
              _self.showscanid = true;
              _self.Selfiescan = true;
              _self.ValidIdCard = true;
              await _self.commonP.hideLoading();
              // _self.Selfie()
              await _self.changeDetectorRef.detectChanges();



            } else {
              var text = "Please reupload the your ID card";
              _self.uploadCardImageError(text);
              await _self.commonP.hideLoading();
              await _self.changeDetectorRef.detectChanges();

            }
          });
      }
      else {


        await this.auth.getIdWise(journeyId)
          .then(async (data: any) => {
            console.log(data, "getIdWise")
            debugger
            // await this.commonP.hideLoading();
            if (data?.response?.code == 1) {
              // 
              var _self = this;
              _self.ValidIdCard = true;
              debugger

              if (accountType == 'A' && data?.response?.content?.gender == "Male") {

                await this.commonP.hideLoading();


                this.translate
                  .get(["Sorry", "err-amalRestriction", "OK"])
                  .subscribe((data) => {
                    this.commonP
                      .showErrorAlert(
                        data["Sorry"],
                        data["err-amalRestriction"],
                        data["OK"],
                        this._router
                      )
                      .then((data: any) => { });
                  });



                this._router.navigateByUrl("/MobileVerification");



              }


              _self.auth.registrationfblObject.journeyId = journeyId
              _self.dataCaptured = true;
              // Front image
              var docImage = data.response.content.frontImage;
              if (docImage) {
                _self.front = _self.Sanitizer.bypassSecurityTrustUrl(
                  "data:image/jpg;base64, " + docImage
                );
                _self.frontBlob = _self.dataURLtoBlob(
                  "data:image/jpg;base64, " + docImage
                );
                _self.auth.registrationfblObject.frontCardImage = docImage;
                _self.frontHide = "1";
                _self.frontsuccess = true;
              }
              // back image
              var backImage = data.response.content.backImage;
              if (backImage) {
                _self.back = _self.Sanitizer.bypassSecurityTrustUrl(
                  "data:image/jpg;base64, " + backImage
                );
                _self.backBlob = _self.dataURLtoBlob(
                  "data:image/jpg;base64, " + backImage
                );
                _self.auth.registrationfblObject.backCardImage = backImage;
                _self.frontHide = "1";
                _self.frontsuccess = true;
              }
              // Face image
              var faceimage = data.response.content.selfie;
              if (faceimage) {
                _self.face = _self.Sanitizer.bypassSecurityTrustUrl(
                  "data:image/jpg;base64, " + faceimage
                );
                _self.faceBlob = _self.dataURLtoBlob(
                  "data:image/jpg;base64, " + faceimage
                );
                _self.auth.registrationfblObject.personFaceImage =
                  faceimage;
                _self.auth.registrationfblObject.selfieimage = faceimage;
                _self.frontHide = "1";
                _self.faceimage = true;
              }


              if (data.response.content.nationalitycode) {





                _self.auth.registrationfblObject.issuer = data.response.content.nationalitycode;
                _self.auth.registrationfblObject.nationality =
                  data.response.content.nationalitycode;
                _self.auth.registrationfblObject.familyName = data.response.content.lastName
                _self.auth.registrationObject.FatherName = data.response.content.fatherName
                _self.auth.registrationfblObject.middleName = data.response.content.middleName
                  ? data.response.content.middleName.trim()
                  : "";

                _self.auth.registrationfblObject.firstName = data.response.content.firstName

                _self.auth.registrationfblObject.documentNumber = data.response.content.cnic

                _self.auth.registrationfblObject.documentCode = "I";
                _self.auth.registrationfblObject.countryID =
                  data.response.content.nationalitycode;
                var dateOfBirth = moment(data.response.content.dob).format('MM/D/YYYY');
                _self.auth.registrationfblObject.dOB = dateOfBirth

                var dateOfIssue = moment(data.response.content.issueDate).format('MM/D/YYYY');
                _self.auth.registrationfblObject.issuedate = dateOfIssue
                _self.auth.registrationfblObject.IsLifeTimeCnic =
                  data.response.content.islifeTimeCnic
                    ? data.response.content.islifeTimeCnic
                    : false;
                debugger;

                var dateOfExpiry = moment(data.response.content.idExpiry).format('MM/D/YYYY');
                if (dateOfExpiry) {
                  _self.auth.registrationfblObject.dOE = dateOfExpiry
                  var dateOfIssue = moment(data.response.content.issueDate).format('MM/D/YYYY');
                  _self.auth.registrationfblObject.dOI = dateOfIssue

                  if (!_self.auth.registrationfblObject.IsLifeTimeCnic) {
                    if (_self.auth.registrationfblObject.dOE == "0/0/0") {
                      _self.auth.registrationfblObject.dOE = dateOfExpiry
                    }
                  }

                  if (_self.auth.registrationfblObject.dOI == "0/0/0") {
                    _self.auth.registrationfblObject.dOI = dateOfIssue
                  }
                } else {
                }
                _self.IslifeTime =
                  _self.auth.registrationfblObject.IsLifeTimeCnic;

                if (_self.IslifeTime) {
                  _self.showdoe = false;
                } else {
                  _self.IsNotlifeTime = true;
                  _self.showdoe = true;
                  var expiry = dateOfExpiry.split("/")
                  console.log(expiry, "expiry")
                  _self.DoedaySelect = expiry[1].toString();
                  _self.DoeMonthSelect = expiry[0].toString();
                  _self.DoeYearSelect = expiry[2].toString();
                }
                _self.ScanType = "I";
                console.log(_self.auth.registrationfblObject);
              } else {
              }
              debugger;


              _self.FirstName =
                _self.auth.registrationfblObject?.firstName;
              _self.MiddleName =
                _self.auth.registrationfblObject?.middleName;
              _self.LastName =
                _self.auth.registrationfblObject?.familyName;
              _self.FatherName =
                _self.auth.registrationObject?.FatherName;
              _self.IDNumber =
                _self.auth.registrationfblObject?.documentNumber;
              console.log(_self.auth.registrationfblObject, "_self.auth.registrationfblObject")
              if (data.response.content.gender) {
                if (data.response.content.gender == "Male") {
                  _self.auth.registrationfblObject.gender = data.response.content.gender;
                  _self.Gender = data.response.content.gender;

                  _self.ValidGender = true;
                } else if (data.response.content.gender == "Female") {
                  _self.auth.registrationfblObject.gender = data.response.content.gender;
                  _self.Gender = data.response.content.gender;

                  _self.ValidGender = true;
                }
              } else {
                debugger
                if (_self.IDNumber) {
                  debugger
                  let lastdigit = Number(_self.IDNumber) % 10;
                  if (lastdigit % 2 == 0) {
                    _self.auth.registrationfblObject.gender = data.response.content.gender;
                    _self.Gender = data.response.content.gender;
                    _self.ValidGender = false;
                    _self.commonP.Set("IDGendertype", _self.Gender);
                  } else {
                    // _self.auth.registrationfblObject.gender = data.response.content.gender;
                    _self.Gender = data.response.content.gender;
                    _self.commonP.Set("IDGendertype", _self.Gender);
                    _self.ValidGender = false;
                  }
                }
              }
              var Birth = dateOfBirth.split("/")
              console.log(Birth, "Birth")
              _self.DobdaySelect = Birth[1].toString();
              console.log(_self.DobdaySelect, "Value");
              console.log("ARRAY", _self.dobdayslistArray);

              _self.DobMonthSelect = Birth[0].toString();
              _self.DobYearSelect = Birth[2].toString();
              var Issue = dateOfIssue.split("/")
              console.log(Issue, "Issue")
              _self.issuedaySelect = Issue[1].toString();
              _self.issueMonthSelect = Issue[0].toString();
              _self.issueYearSelect = Issue[2].toString();

              // _self.cnictype = true;
              // _self.IDtype = "CNIC";

              if (data.response.content.documentType == "Smart National Identity Card") {
                debugger
                _self.snictype = true;
                _self.cnictype = false;
                _self.IDtype = "SNIC";
              } else {
                _self.cnictype = true;
                _self.snictype = false;
                _self.IDtype = "CNIC";
              }

              _self.ScanID = true;
              _self.showscanid = true;
              _self.Selfiescan = true;
              debugger



               await _self.commonP.hideLoading();
              _self.changeDetectorRef.detectChanges();

            } else {
              debugger
              var text = "Please reupload the your ID card";
              _self.uploadCardImageError(text);
              await _self.commonP.hideLoading();
              await _self.changeDetectorRef.detectChanges();

            }
          });
      }
    });
  }
}
